/**
 * Auto-generated Locale Data File for ja-JP.
 * This is generated in the @box/cldr-data project.
 * @IMPORTANT: DO NOT MODIFY THIS FILE DIRECTLY
 */

import type { NumberFormat, NumbersData, NameItem, LanguagesData, LocaleData, TimeZone, TimeZoneList, WeekData, WeekDayNameData, NameSet, WeekDayNames } from '../types';

const languages: LanguagesData = {
    id: 19,
    bcp47Tag: 'ja-JP',
    name: 'Japanese',
    localizedName: '日本語',
    localizedNameList: [
        {
            id: 59,
            name: 'イギリス英語',
        },
        {
            id: 16,
            name: 'イタリア語',
        },
        {
            id: 67,
            name: 'オーストラリア英語',
        },
        {
            id: 24,
            name: 'オランダ語',
        },
        {
            id: 66,
            name: 'カナダ英語',
        },
        {
            id: 57,
            name: 'スウェーデン語',
        },
        {
            id: 10,
            name: 'スペイン語',
        },
        {
            id: 72,
            name: 'スペイン語 (ラテンアメリカ)',
        },
        {
            id: 68,
            name: 'デンマーク語',
        },
        {
            id: 18,
            name: 'ドイツ語',
        },
        {
            id: 49,
            name: 'トルコ語',
        },
        {
            id: 69,
            name: 'ノルウェー語(ブークモール)',
        },
        {
            id: 71,
            name: 'ヒンディー語',
        },
        {
            id: 61,
            name: 'フィンランド語',
        },
        {
            id: 21,
            name: 'フランス語',
        },
        {
            id: 65,
            name: 'フランス語 (カナダ)',
        },
        {
            id: 70,
            name: 'ベンガル語',
        },
        {
            id: 30,
            name: 'ポーランド語',
        },
        {
            id: 14,
            name: 'ポルトガル語',
        },
        {
            id: 8,
            name: 'ロシア語',
        },
        {
            id: 4,
            name: '英語',
        },
        {
            id: 6,
            name: '簡体中国語',
        },
        {
            id: 55,
            name: '韓国語',
        },
        {
            id: 19,
            name: '日本語',
        },
        {
            id: 63,
            name: '繁体中国語',
        },
    ],
};

const numbers: NumbersData = {
    long: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 4,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number}万',
        },
        {
            digits: 2,
            msg: '{count, number}万',
        },
        {
            digits: 3,
            msg: '{count, number}万',
        },
        {
            digits: 4,
            msg: '{count, number}万',
        },
        {
            digits: 1,
            msg: '{count, number}億',
        },
        {
            digits: 2,
            msg: '{count, number}億',
        },
        {
            digits: 3,
            msg: '{count, number}億',
        },
        {
            digits: 4,
            msg: '{count, number}億',
        },
        {
            digits: 1,
            msg: '{count, number}兆',
        },
        {
            digits: 2,
            msg: '{count, number}兆',
        },
    ],
    short: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 4,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number}万',
        },
        {
            digits: 2,
            msg: '{count, number}万',
        },
        {
            digits: 3,
            msg: '{count, number}万',
        },
        {
            digits: 4,
            msg: '{count, number}万',
        },
        {
            digits: 1,
            msg: '{count, number}億',
        },
        {
            digits: 2,
            msg: '{count, number}億',
        },
        {
            digits: 3,
            msg: '{count, number}億',
        },
        {
            digits: 4,
            msg: '{count, number}億',
        },
        {
            digits: 1,
            msg: '{count, number}兆',
        },
        {
            digits: 2,
            msg: '{count, number}兆',
        },
    ],
};

const timezones: Array<TimeZone> = [
    {
        name: 'Etc/GMT-14',
        displayName: 'GMT+14:00 GMT-14 +14',
        nameLocalized: 'GMT-14',
        abbreviationStandard: '+14',
        id: 375
    },
    {
        name: 'Pacific/Kiritimati',
        displayName: 'GMT+14:00 キリスィマスィ島 +14',
        nameLocalized: 'キリスィマスィ島',
        abbreviationStandard: '+14',
        id: 500,
        enabled: true
    },
    {
        name: 'Etc/GMT-13',
        displayName: 'GMT+13:00 GMT-13 +13',
        nameLocalized: 'GMT-13',
        abbreviationStandard: '+13',
        id: 374
    },
    {
        name: 'Pacific/Apia',
        displayName: 'GMT+13:00 アピア +13/+14',
        nameLocalized: 'アピア',
        abbreviationStandard: '+13/+14',
        id: 485
    },
    {
        name: 'Pacific/Tongatapu',
        displayName: 'GMT+13:00 トンガタプ +13/+14',
        nameLocalized: 'トンガタプ',
        abbreviationStandard: '+13/+14',
        id: 520,
        enabled: true
    },
    {
        name: 'Pacific/Fakaofo',
        displayName: 'GMT+13:00 ファカオフォ +13',
        nameLocalized: 'ファカオフォ',
        abbreviationStandard: '+13',
        id: 491
    },
    {
        name: 'Pacific/Chatham',
        displayName: 'GMT+12:45 チャタム +1245/+1345',
        nameLocalized: 'チャタム',
        abbreviationStandard: '+1245/+1345',
        abbreviationDaylight: '+1245/+1345',
        id: 487
    },
    {
        name: 'Kwajalein',
        displayName: 'GMT+12:00 Kwajalein +12',
        nameLocalized: 'Kwajalein',
        abbreviationStandard: '+12',
        id: 474
    },
    {
        name: 'NZ',
        displayName: 'GMT+12:00 NZ NZST',
        nameLocalized: 'NZ',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 483
    },
    {
        name: 'Antarctica/South_Pole',
        displayName: 'GMT+12:00 South Pole NZST',
        nameLocalized: 'South Pole',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 209
    },
    {
        name: 'Asia/Anadyr',
        displayName: 'GMT+12:00 アナディリ +12',
        nameLocalized: 'アナディリ',
        abbreviationStandard: '+12',
        id: 216
    },
    {
        name: 'Pacific/Wake',
        displayName: 'GMT+12:00 ウェーク島 +12',
        nameLocalized: 'ウェーク島',
        abbreviationStandard: '+12',
        id: 522
    },
    {
        name: 'Pacific/Wallis',
        displayName: 'GMT+12:00 ウォリス諸島 +12',
        nameLocalized: 'ウォリス諸島',
        abbreviationStandard: '+12',
        id: 523
    },
    {
        name: 'Pacific/Auckland',
        displayName: 'GMT+12:00 オークランド NZST',
        nameLocalized: 'オークランド',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 486,
        enabled: true
    },
    {
        name: 'Asia/Kamchatka',
        displayName: 'GMT+12:00 カムチャッカ +12',
        nameLocalized: 'カムチャッカ',
        abbreviationStandard: '+12',
        id: 249
    },
    {
        name: 'Pacific/Kwajalein',
        displayName: 'GMT+12:00 クェゼリン +12',
        nameLocalized: 'クェゼリン',
        abbreviationStandard: '+12',
        id: 502
    },
    {
        name: 'Pacific/Tarawa',
        displayName: 'GMT+12:00 タラワ +12',
        nameLocalized: 'タラワ',
        abbreviationStandard: '+12',
        id: 519
    },
    {
        name: 'Pacific/Nauru',
        displayName: 'GMT+12:00 ナウル +12',
        nameLocalized: 'ナウル',
        abbreviationStandard: '+12',
        id: 506
    },
    {
        name: 'Pacific/Fiji',
        displayName: 'GMT+12:00 フィジー +12/+13',
        nameLocalized: 'フィジー',
        abbreviationStandard: '+12/+13',
        id: 492,
        enabled: true
    },
    {
        name: 'Pacific/Funafuti',
        displayName: 'GMT+12:00 フナフティ +12',
        nameLocalized: 'フナフティ',
        abbreviationStandard: '+12',
        id: 493
    },
    {
        name: 'Antarctica/McMurdo',
        displayName: 'GMT+12:00 マクマード基地 NZST',
        nameLocalized: 'マクマード基地',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 206
    },
    {
        name: 'Pacific/Majuro',
        displayName: 'GMT+12:00 マジュロ +12',
        nameLocalized: 'マジュロ',
        abbreviationStandard: '+12',
        id: 503
    },
    {
        name: 'Pacific/Efate',
        displayName: 'GMT+11:00 エフェテ島 +11/+12',
        nameLocalized: 'エフェテ島',
        abbreviationStandard: '+11/+12',
        id: 489
    },
    {
        name: 'Pacific/Guadalcanal',
        displayName: 'GMT+11:00 ガダルカナル +11',
        nameLocalized: 'ガダルカナル',
        abbreviationStandard: '+11',
        id: 496
    },
    {
        name: 'Pacific/Kosrae',
        displayName: 'GMT+11:00 コスラエ +11',
        nameLocalized: 'コスラエ',
        abbreviationStandard: '+11',
        id: 501
    },
    {
        name: 'Asia/Sakhalin',
        displayName: 'GMT+11:00 サハリン +11',
        nameLocalized: 'サハリン',
        abbreviationStandard: '+11',
        id: 275
    },
    {
        name: 'Pacific/Noumea',
        displayName: 'GMT+11:00 ヌメア +11/+12',
        nameLocalized: 'ヌメア',
        abbreviationStandard: '+11/+12',
        id: 509
    },
    {
        name: 'Pacific/Norfolk',
        displayName: 'GMT+11:00 ノーフォーク島 +11/+12',
        nameLocalized: 'ノーフォーク島',
        abbreviationStandard: '+11/+12',
        abbreviationDaylight: '+11/+12',
        id: 508
    },
    {
        name: 'Pacific/Ponape',
        displayName: 'GMT+11:00 ポンペイ島 +11',
        nameLocalized: 'ポンペイ島',
        abbreviationStandard: '+11',
        id: 513
    },
    {
        name: 'Asia/Magadan',
        displayName: 'GMT+11:00 マガダン +11',
        nameLocalized: 'マガダン',
        abbreviationStandard: '+11',
        id: 259,
        enabled: true
    },
    {
        name: 'Australia/LHI',
        displayName: 'GMT+10:30 LHI +1030/+11',
        nameLocalized: 'LHI',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 318
    },
    {
        name: 'Australia/Lord_Howe',
        displayName: 'GMT+10:30 ロードハウ +1030/+11',
        nameLocalized: 'ロードハウ',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 320
    },
    {
        name: 'Australia/ACT',
        displayName: 'GMT+10:00 ACT AEST',
        nameLocalized: 'ACT',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 309
    },
    {
        name: 'Australia/Canberra',
        displayName: 'GMT+10:00 Canberra AEST',
        nameLocalized: 'Canberra',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 313
    },
    {
        name: 'Australia/Currie',
        displayName: 'GMT+10:00 Currie AEST',
        nameLocalized: 'Currie',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 314
    },
    {
        name: 'Australia/NSW',
        displayName: 'GMT+10:00 NSW AEST',
        nameLocalized: 'NSW',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 323
    },
    {
        name: 'Australia/Queensland',
        displayName: 'GMT+10:00 Queensland AEST',
        nameLocalized: 'Queensland',
        abbreviationStandard: 'AEST',
        id: 325
    },
    {
        name: 'Australia/Tasmania',
        displayName: 'GMT+10:00 Tasmania AEST',
        nameLocalized: 'Tasmania',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 328
    },
    {
        name: 'Australia/Victoria',
        displayName: 'GMT+10:00 Victoria AEST',
        nameLocalized: 'Victoria',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 329
    },
    {
        name: 'Pacific/Yap',
        displayName: 'GMT+10:00 Yap +10',
        nameLocalized: 'Yap',
        abbreviationStandard: '+10',
        id: 524
    },
    {
        name: 'Asia/Vladivostok',
        displayName: 'GMT+10:00 ウラジオストク +10',
        nameLocalized: 'ウラジオストク',
        abbreviationStandard: '+10',
        id: 293,
        enabled: true
    },
    {
        name: 'Pacific/Guam',
        displayName: 'GMT+10:00 グアム ChST',
        nameLocalized: 'グアム',
        abbreviationStandard: 'ChST',
        id: 497,
        enabled: true
    },
    {
        name: 'Pacific/Saipan',
        displayName: 'GMT+10:00 サイパン ChST',
        nameLocalized: 'サイパン',
        abbreviationStandard: 'ChST',
        id: 516
    },
    {
        name: 'Australia/Sydney',
        displayName: 'GMT+10:00 シドニー AEST',
        nameLocalized: 'シドニー',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 327,
        enabled: true
    },
    {
        name: 'Pacific/Truk',
        displayName: 'GMT+10:00 チューク +10',
        nameLocalized: 'チューク',
        abbreviationStandard: '+10',
        id: 521
    },
    {
        name: 'Antarctica/DumontDUrville',
        displayName: 'GMT+10:00 デュモン・デュルヴィル基地 +10',
        nameLocalized: 'デュモン・デュルヴィル基地',
        abbreviationStandard: '+10',
        id: 204
    },
    {
        name: 'Australia/Brisbane',
        displayName: 'GMT+10:00 ブリスベン AEST',
        nameLocalized: 'ブリスベン',
        abbreviationStandard: 'AEST',
        id: 311,
        enabled: true
    },
    {
        name: 'Pacific/Port_Moresby',
        displayName: 'GMT+10:00 ポートモレスビー +10',
        nameLocalized: 'ポートモレスビー',
        abbreviationStandard: '+10',
        id: 514
    },
    {
        name: 'Australia/Hobart',
        displayName: 'GMT+10:00 ホバート AEST',
        nameLocalized: 'ホバート',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 317,
        enabled: true
    },
    {
        name: 'Australia/Melbourne',
        displayName: 'GMT+10:00 メルボルン AEST',
        nameLocalized: 'メルボルン',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 321
    },
    {
        name: 'Australia/Lindeman',
        displayName: 'GMT+10:00 リンデマン AEST',
        nameLocalized: 'リンデマン',
        abbreviationStandard: 'AEST',
        id: 319
    },
    {
        name: 'Australia/North',
        displayName: 'GMT+09:30 North ACST',
        nameLocalized: 'North',
        abbreviationStandard: 'ACST',
        id: 322
    },
    {
        name: 'Australia/South',
        displayName: 'GMT+09:30 South ACST',
        nameLocalized: 'South',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 326
    },
    {
        name: 'Australia/Yancowinna',
        displayName: 'GMT+09:30 Yancowinna ACST',
        nameLocalized: 'Yancowinna',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 331
    },
    {
        name: 'Australia/Adelaide',
        displayName: 'GMT+09:30 アデレード ACST',
        nameLocalized: 'アデレード',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 310,
        enabled: true
    },
    {
        name: 'Australia/Darwin',
        displayName: 'GMT+09:30 ダーウィン ACST',
        nameLocalized: 'ダーウィン',
        abbreviationStandard: 'ACST',
        id: 315,
        enabled: true
    },
    {
        name: 'Australia/Broken_Hill',
        displayName: 'GMT+09:30 ブロークンヒル ACST',
        nameLocalized: 'ブロークンヒル',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 312
    },
    {
        name: 'Asia/Jayapura',
        displayName: 'GMT+09:00 ジャヤプラ WIT',
        nameLocalized: 'ジャヤプラ',
        abbreviationStandard: 'WIT',
        id: 246
    },
    {
        name: 'Asia/Seoul',
        displayName: 'GMT+09:00 ソウル KST',
        nameLocalized: 'ソウル',
        abbreviationStandard: 'KST',
        id: 277,
        enabled: true
    },
    {
        name: 'Asia/Dili',
        displayName: 'GMT+09:00 ディリ +09',
        nameLocalized: 'ディリ',
        abbreviationStandard: '+09',
        id: 236
    },
    {
        name: 'Pacific/Palau',
        displayName: 'GMT+09:00 パラオ +09',
        nameLocalized: 'パラオ',
        abbreviationStandard: '+09',
        id: 511
    },
    {
        name: 'Asia/Yakutsk',
        displayName: 'GMT+09:00 ヤクーツク +09',
        nameLocalized: 'ヤクーツク',
        abbreviationStandard: '+09',
        id: 294,
        enabled: true
    },
    {
        name: 'Asia/Tokyo',
        displayName: 'GMT+09:00 東京 JST',
        nameLocalized: '東京',
        abbreviationStandard: 'JST',
        id: 287,
        enabled: true
    },
    {
        name: 'Asia/Pyongyang',
        displayName: 'GMT+09:00 平壌 KST',
        nameLocalized: '平壌',
        abbreviationStandard: 'KST',
        id: 269
    },
    {
        name: 'Australia/Eucla',
        displayName: 'GMT+08:45 ユークラ +0845/+0945',
        nameLocalized: 'ユークラ',
        abbreviationStandard: '+0845/+0945',
        id: 316
    },
    {
        name: 'Asia/Chongqing',
        displayName: 'GMT+08:00 Chongqing CST',
        nameLocalized: 'Chongqing',
        abbreviationStandard: 'CST',
        id: 230
    },
    {
        name: 'Asia/Chungking',
        displayName: 'GMT+08:00 Chungking CST',
        nameLocalized: 'Chungking',
        abbreviationStandard: 'CST',
        id: 231
    },
    {
        name: 'Asia/Harbin',
        displayName: 'GMT+08:00 Harbin CST',
        nameLocalized: 'Harbin',
        abbreviationStandard: 'CST',
        id: 240
    },
    {
        name: 'Asia/Kashgar',
        displayName: 'GMT+08:00 Kashgar CST',
        nameLocalized: 'Kashgar',
        abbreviationStandard: 'CST',
        id: 251
    },
    {
        name: 'Asia/Ulan_Bator',
        displayName: 'GMT+08:00 Ulan Bator +08/+09',
        nameLocalized: 'Ulan Bator',
        abbreviationStandard: '+08/+09',
        id: 290
    },
    {
        name: 'Asia/Irkutsk',
        displayName: 'GMT+08:00 イルクーツク +08',
        nameLocalized: 'イルクーツク',
        abbreviationStandard: '+08',
        id: 243
    },
    {
        name: 'Asia/Ulaanbaatar',
        displayName: 'GMT+08:00 ウランバートル +08/+09',
        nameLocalized: 'ウランバートル',
        abbreviationStandard: '+08/+09',
        id: 289,
        enabled: true
    },
    {
        name: 'Asia/Kuala_Lumpur',
        displayName: 'GMT+08:00 クアラルンプール +08',
        nameLocalized: 'クアラルンプール',
        abbreviationStandard: '+08',
        id: 254,
        enabled: true
    },
    {
        name: 'Asia/Kuching',
        displayName: 'GMT+08:00 クチン +08',
        nameLocalized: 'クチン',
        abbreviationStandard: '+08',
        id: 255
    },
    {
        name: 'Antarctica/Casey',
        displayName: 'GMT+08:00 ケーシー基地 +08',
        nameLocalized: 'ケーシー基地',
        abbreviationStandard: '+08',
        id: 202
    },
    {
        name: 'Asia/Singapore',
        displayName: 'GMT+08:00 シンガポール +08',
        nameLocalized: 'シンガポール',
        abbreviationStandard: '+08',
        id: 279
    },
    {
        name: 'Asia/Choibalsan',
        displayName: 'GMT+08:00 チョイバルサン +08/+09',
        nameLocalized: 'チョイバルサン',
        abbreviationStandard: '+08/+09',
        id: 229
    },
    {
        name: 'Australia/Perth',
        displayName: 'GMT+08:00 パース AWST',
        nameLocalized: 'パース',
        abbreviationStandard: 'AWST',
        id: 324,
        enabled: true
    },
    {
        name: 'Asia/Brunei',
        displayName: 'GMT+08:00 ブルネイ +08',
        nameLocalized: 'ブルネイ',
        abbreviationStandard: '+08',
        id: 227
    },
    {
        name: 'Asia/Macau',
        displayName: 'GMT+08:00 マカオ CST',
        nameLocalized: 'マカオ',
        abbreviationStandard: 'CST',
        id: 258
    },
    {
        name: 'Asia/Makassar',
        displayName: 'GMT+08:00 マカッサル WITA',
        nameLocalized: 'マカッサル',
        abbreviationStandard: 'WITA',
        id: 260
    },
    {
        name: 'Asia/Manila',
        displayName: 'GMT+08:00 マニラ PST',
        nameLocalized: 'マニラ',
        abbreviationStandard: 'PST',
        id: 261
    },
    {
        name: 'Asia/Hong_Kong',
        displayName: 'GMT+08:00 香港 HKST',
        nameLocalized: '香港',
        abbreviationStandard: 'HKST',
        id: 241,
        enabled: true
    },
    {
        name: 'Asia/Shanghai',
        displayName: 'GMT+08:00 上海 CST',
        nameLocalized: '上海',
        abbreviationStandard: 'CST',
        id: 278,
        enabled: true
    },
    {
        name: 'Asia/Taipei',
        displayName: 'GMT+08:00 台北 CST',
        nameLocalized: '台北',
        abbreviationStandard: 'CST',
        id: 280,
        enabled: true
    },
    {
        name: 'Asia/Krasnoyarsk',
        displayName: 'GMT+07:00 クラスノヤルスク +07',
        nameLocalized: 'クラスノヤルスク',
        abbreviationStandard: '+07',
        id: 253,
        enabled: true
    },
    {
        name: 'Indian/Christmas',
        displayName: 'GMT+07:00 クリスマス島 +07',
        nameLocalized: 'クリスマス島',
        abbreviationStandard: '+07',
        id: 461
    },
    {
        name: 'Asia/Jakarta',
        displayName: 'GMT+07:00 ジャカルタ WIB',
        nameLocalized: 'ジャカルタ',
        abbreviationStandard: 'WIB',
        id: 245
    },
    {
        name: 'Antarctica/Davis',
        displayName: 'GMT+07:00 デービス基地 +07',
        nameLocalized: 'デービス基地',
        abbreviationStandard: '+07',
        id: 203
    },
    {
        name: 'Asia/Novosibirsk',
        displayName: 'GMT+07:00 ノヴォシビルスク +07',
        nameLocalized: 'ノヴォシビルスク',
        abbreviationStandard: '+07',
        id: 264
    },
    {
        name: 'Asia/Bangkok',
        displayName: 'GMT+07:00 バンコク +07',
        nameLocalized: 'バンコク',
        abbreviationStandard: '+07',
        id: 224,
        enabled: true
    },
    {
        name: 'Asia/Vientiane',
        displayName: 'GMT+07:00 ビエンチャン +07',
        nameLocalized: 'ビエンチャン',
        abbreviationStandard: '+07',
        id: 292
    },
    {
        name: 'Asia/Phnom_Penh',
        displayName: 'GMT+07:00 プノンペン +07',
        nameLocalized: 'プノンペン',
        abbreviationStandard: '+07',
        id: 267
    },
    {
        name: 'Asia/Saigon',
        displayName: 'GMT+07:00 ホーチミン +07',
        nameLocalized: 'ホーチミン',
        abbreviationStandard: '+07',
        id: 274
    },
    {
        name: 'Asia/Hovd',
        displayName: 'GMT+07:00 ホブド +07/+08',
        nameLocalized: 'ホブド',
        abbreviationStandard: '+07/+08',
        id: 242
    },
    {
        name: 'Asia/Pontianak',
        displayName: 'GMT+07:00 ポンティアナック WIB',
        nameLocalized: 'ポンティアナック',
        abbreviationStandard: 'WIB',
        id: 268
    },
    {
        name: 'Indian/Cocos',
        displayName: 'GMT+06:30 ココス諸島 +0630',
        nameLocalized: 'ココス諸島',
        abbreviationStandard: '+0630',
        id: 462
    },
    {
        name: 'Asia/Urumqi',
        displayName: 'GMT+06:00 ウルムチ +06',
        nameLocalized: 'ウルムチ',
        abbreviationStandard: '+06',
        id: 291
    },
    {
        name: 'Asia/Omsk',
        displayName: 'GMT+06:00 オムスク +06',
        nameLocalized: 'オムスク',
        abbreviationStandard: '+06',
        id: 265
    },
    {
        name: 'Asia/Dhaka',
        displayName: 'GMT+06:00 ダッカ +06/+07',
        nameLocalized: 'ダッカ',
        abbreviationStandard: '+06/+07',
        id: 235,
        enabled: true
    },
    {
        name: 'Indian/Chagos',
        displayName: 'GMT+06:00 チャゴス +06',
        nameLocalized: 'チャゴス',
        abbreviationStandard: '+06',
        id: 460
    },
    {
        name: 'Asia/Thimphu',
        displayName: 'GMT+06:00 ティンプー +06',
        nameLocalized: 'ティンプー',
        abbreviationStandard: '+06',
        id: 286
    },
    {
        name: 'Asia/Bishkek',
        displayName: 'GMT+06:00 ビシュケク +06',
        nameLocalized: 'ビシュケク',
        abbreviationStandard: '+06',
        id: 226
    },
    {
        name: 'Asia/Colombo',
        displayName: 'GMT+05:30 コロンボ +0530',
        nameLocalized: 'コロンボ',
        abbreviationStandard: '+0530',
        id: 232,
        enabled: true
    },
    {
        name: 'Asia/Aqtau',
        displayName: 'GMT+05:00 アクタウ +05',
        nameLocalized: 'アクタウ',
        abbreviationStandard: '+05',
        id: 217
    },
    {
        name: 'Asia/Aqtobe',
        displayName: 'GMT+05:00 アクトベ +05',
        nameLocalized: 'アクトベ',
        abbreviationStandard: '+05',
        id: 218
    },
    {
        name: 'Asia/Ashgabat',
        displayName: 'GMT+05:00 アシガバード +05',
        nameLocalized: 'アシガバード',
        abbreviationStandard: '+05',
        id: 219
    },
    {
        name: 'Asia/Almaty',
        displayName: 'GMT+05:00 アルマトイ +05',
        nameLocalized: 'アルマトイ',
        abbreviationStandard: '+05',
        id: 214,
        enabled: true
    },
    {
        name: 'Asia/Yekaterinburg',
        displayName: 'GMT+05:00 エカテリンブルグ +05',
        nameLocalized: 'エカテリンブルグ',
        abbreviationStandard: '+05',
        id: 295,
        enabled: true
    },
    {
        name: 'Asia/Oral',
        displayName: 'GMT+05:00 オラル +05',
        nameLocalized: 'オラル',
        abbreviationStandard: '+05',
        id: 266
    },
    {
        name: 'Asia/Karachi',
        displayName: 'GMT+05:00 カラチ PKST',
        nameLocalized: 'カラチ',
        abbreviationStandard: 'PKST',
        id: 250,
        enabled: true
    },
    {
        name: 'Asia/Qyzylorda',
        displayName: 'GMT+05:00 クズロルダ +05',
        nameLocalized: 'クズロルダ',
        abbreviationStandard: '+05',
        id: 271
    },
    {
        name: 'Indian/Kerguelen',
        displayName: 'GMT+05:00 ケルゲレン諸島 +05',
        nameLocalized: 'ケルゲレン諸島',
        abbreviationStandard: '+05',
        id: 464
    },
    {
        name: 'Asia/Samarkand',
        displayName: 'GMT+05:00 サマルカンド +05',
        nameLocalized: 'サマルカンド',
        abbreviationStandard: '+05',
        id: 276
    },
    {
        name: 'Asia/Tashkent',
        displayName: 'GMT+05:00 タシケント +05',
        nameLocalized: 'タシケント',
        abbreviationStandard: '+05',
        id: 281
    },
    {
        name: 'Asia/Dushanbe',
        displayName: 'GMT+05:00 ドゥシャンベ +05',
        nameLocalized: 'ドゥシャンベ',
        abbreviationStandard: '+05',
        id: 238
    },
    {
        name: 'Antarctica/Vostok',
        displayName: 'GMT+05:00 ボストーク基地 +05',
        nameLocalized: 'ボストーク基地',
        abbreviationStandard: '+05',
        id: 211
    },
    {
        name: 'Antarctica/Mawson',
        displayName: 'GMT+05:00 モーソン基地 +05',
        nameLocalized: 'モーソン基地',
        abbreviationStandard: '+05',
        id: 205
    },
    {
        name: 'Indian/Maldives',
        displayName: 'GMT+05:00 モルディブ +05',
        nameLocalized: 'モルディブ',
        abbreviationStandard: '+05',
        id: 466
    },
    {
        name: 'Asia/Kabul',
        displayName: 'GMT+04:30 カブール +0430',
        nameLocalized: 'カブール',
        abbreviationStandard: '+0430',
        id: 248,
        enabled: true
    },
    {
        name: 'Asia/Yerevan',
        displayName: 'GMT+04:00 エレバン +04/+05',
        nameLocalized: 'エレバン',
        abbreviationStandard: '+04/+05',
        id: 296,
        enabled: true
    },
    {
        name: 'Europe/Samara',
        displayName: 'GMT+04:00 サマラ +04',
        nameLocalized: 'サマラ',
        abbreviationStandard: '+04',
        id: 428
    },
    {
        name: 'Asia/Dubai',
        displayName: 'GMT+04:00 ドバイ +04',
        nameLocalized: 'ドバイ',
        abbreviationStandard: '+04',
        id: 237
    },
    {
        name: 'Asia/Tbilisi',
        displayName: 'GMT+04:00 トビリシ +04',
        nameLocalized: 'トビリシ',
        abbreviationStandard: '+04',
        id: 282,
        enabled: true
    },
    {
        name: 'Asia/Baku',
        displayName: 'GMT+04:00 バクー +04/+05',
        nameLocalized: 'バクー',
        abbreviationStandard: '+04/+05',
        id: 223,
        enabled: true
    },
    {
        name: 'Asia/Muscat',
        displayName: 'GMT+04:00 マスカット +04',
        nameLocalized: 'マスカット',
        abbreviationStandard: '+04',
        id: 262,
        enabled: true
    },
    {
        name: 'Indian/Mahe',
        displayName: 'GMT+04:00 マヘ +04',
        nameLocalized: 'マヘ',
        abbreviationStandard: '+04',
        id: 465
    },
    {
        name: 'Indian/Mauritius',
        displayName: 'GMT+04:00 モーリシャス +04/+05',
        nameLocalized: 'モーリシャス',
        abbreviationStandard: '+04/+05',
        id: 467
    },
    {
        name: 'Indian/Reunion',
        displayName: 'GMT+04:00 レユニオン +04',
        nameLocalized: 'レユニオン',
        abbreviationStandard: '+04',
        id: 469
    },
    {
        name: 'Asia/Tehran',
        displayName: 'GMT+03:30 テヘラン +0330/+0430',
        nameLocalized: 'テヘラン',
        abbreviationStandard: '+0330/+0430',
        id: 283,
        enabled: true
    },
    {
        name: 'Africa/Asmara',
        displayName: 'GMT+03:00 Asmara EAT',
        nameLocalized: 'Asmara',
        abbreviationStandard: 'EAT',
        id: 5
    },
    {
        name: 'Asia/Istanbul',
        displayName: 'GMT+03:00 Istanbul +03',
        nameLocalized: 'Istanbul',
        abbreviationStandard: '+03',
        id: 407
    },
    {
        name: 'Europe/Tiraspol',
        displayName: 'GMT+03:00 Tiraspol MSK/MSD',
        nameLocalized: 'Tiraspol',
        abbreviationStandard: 'MSK/MSD',
        id: 437
    },
    {
        name: 'Africa/Addis_Ababa',
        displayName: 'GMT+03:00 アジスアベバ EAT',
        nameLocalized: 'アジスアベバ',
        abbreviationStandard: 'EAT',
        id: 3
    },
    {
        name: 'Africa/Asmera',
        displayName: 'GMT+03:00 アスマラ EAT',
        nameLocalized: 'アスマラ',
        abbreviationStandard: 'EAT',
        id: 6
    },
    {
        name: 'Asia/Aden',
        displayName: 'GMT+03:00 アデン +03',
        nameLocalized: 'アデン',
        abbreviationStandard: '+03',
        id: 213
    },
    {
        name: 'Indian/Antananarivo',
        displayName: 'GMT+03:00 アンタナナリボ EAT',
        nameLocalized: 'アンタナナリボ',
        abbreviationStandard: 'EAT',
        id: 459
    },
    {
        name: 'Asia/Amman',
        displayName: 'GMT+03:00 アンマン +03',
        nameLocalized: 'アンマン',
        abbreviationStandard: '+03',
        id: 215,
        enabled: true
    },
    {
        name: 'Europe/Istanbul',
        displayName: 'GMT+03:00 イスタンブール +03',
        nameLocalized: 'イスタンブール',
        abbreviationStandard: '+03',
        id: 244,
        enabled: true
    },
    {
        name: 'Asia/Qatar',
        displayName: 'GMT+03:00 カタール +03',
        nameLocalized: 'カタール',
        abbreviationStandard: '+03',
        id: 270
    },
    {
        name: 'Africa/Kampala',
        displayName: 'GMT+03:00 カンパラ EAT',
        nameLocalized: 'カンパラ',
        abbreviationStandard: 'EAT',
        id: 27
    },
    {
        name: 'Asia/Kuwait',
        displayName: 'GMT+03:00 クウェート +03',
        nameLocalized: 'クウェート',
        abbreviationStandard: '+03',
        id: 256,
        enabled: true
    },
    {
        name: 'Indian/Comoro',
        displayName: 'GMT+03:00 コモロ EAT',
        nameLocalized: 'コモロ',
        abbreviationStandard: 'EAT',
        id: 463
    },
    {
        name: 'Africa/Djibouti',
        displayName: 'GMT+03:00 ジブチ EAT',
        nameLocalized: 'ジブチ',
        abbreviationStandard: 'EAT',
        id: 20
    },
    {
        name: 'Europe/Simferopol',
        displayName: 'GMT+03:00 シンフェロポリ MSK',
        nameLocalized: 'シンフェロポリ',
        abbreviationStandard: 'MSK',
        id: 431
    },
    {
        name: 'Asia/Damascus',
        displayName: 'GMT+03:00 ダマスカス +03',
        nameLocalized: 'ダマスカス',
        abbreviationStandard: '+03',
        id: 234
    },
    {
        name: 'Africa/Dar_es_Salaam',
        displayName: 'GMT+03:00 ダルエスサラーム EAT',
        nameLocalized: 'ダルエスサラーム',
        abbreviationStandard: 'EAT',
        id: 19
    },
    {
        name: 'Africa/Nairobi',
        displayName: 'GMT+03:00 ナイロビ EAT',
        nameLocalized: 'ナイロビ',
        abbreviationStandard: 'EAT',
        id: 43,
        enabled: true
    },
    {
        name: 'Asia/Bahrain',
        displayName: 'GMT+03:00 バーレーン +03',
        nameLocalized: 'バーレーン',
        abbreviationStandard: '+03',
        id: 222
    },
    {
        name: 'Asia/Baghdad',
        displayName: 'GMT+03:00 バグダッド +03/+04',
        nameLocalized: 'バグダッド',
        abbreviationStandard: '+03/+04',
        id: 221,
        enabled: true
    },
    {
        name: 'Europe/Volgograd',
        displayName: 'GMT+03:00 ボルゴグラード MSK',
        nameLocalized: 'ボルゴグラード',
        abbreviationStandard: 'MSK',
        id: 443
    },
    {
        name: 'Indian/Mayotte',
        displayName: 'GMT+03:00 マヨット EAT',
        nameLocalized: 'マヨット',
        abbreviationStandard: 'EAT',
        id: 468
    },
    {
        name: 'Europe/Minsk',
        displayName: 'GMT+03:00 ミンスク +03',
        nameLocalized: 'ミンスク',
        abbreviationStandard: '+03',
        id: 418,
        enabled: true
    },
    {
        name: 'Africa/Mogadishu',
        displayName: 'GMT+03:00 モガディシオ EAT',
        nameLocalized: 'モガディシオ',
        abbreviationStandard: 'EAT',
        id: 41
    },
    {
        name: 'Europe/Moscow',
        displayName: 'GMT+03:00 モスクワ MSK',
        nameLocalized: 'モスクワ',
        abbreviationStandard: 'MSK',
        id: 420,
        enabled: true
    },
    {
        name: 'Asia/Riyadh',
        displayName: 'GMT+03:00 リヤド +03',
        nameLocalized: 'リヤド',
        abbreviationStandard: '+03',
        id: 273
    },
    {
        name: 'Antarctica/Syowa',
        displayName: 'GMT+03:00 昭和基地 +03',
        nameLocalized: '昭和基地',
        abbreviationStandard: '+03',
        id: 210
    },
    {
        name: 'EET',
        displayName: 'GMT+02:00 EET EET',
        nameLocalized: 'EET',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 350
    },
    {
        name: 'Europe/Nicosia',
        displayName: 'GMT+02:00 Nicosia EET',
        nameLocalized: 'Nicosia',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 421
    },
    {
        name: 'Asia/Tel_Aviv',
        displayName: 'GMT+02:00 Tel Aviv IST',
        nameLocalized: 'Tel Aviv',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 284
    },
    {
        name: 'Europe/Uzhgorod',
        displayName: 'GMT+02:00 Uzhgorod EET',
        nameLocalized: 'Uzhgorod',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 438
    },
    {
        name: 'Europe/Zaporozhye',
        displayName: 'GMT+02:00 Zaporozhye EET',
        nameLocalized: 'Zaporozhye',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 446
    },
    {
        name: 'Europe/Athens',
        displayName: 'GMT+02:00 アテネ EET',
        nameLocalized: 'アテネ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 392
    },
    {
        name: 'Europe/Vilnius',
        displayName: 'GMT+02:00 ヴィリニュス EET',
        nameLocalized: 'ヴィリニュス',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 442
    },
    {
        name: 'Africa/Windhoek',
        displayName: 'GMT+02:00 ウィントフック WAT',
        nameLocalized: 'ウィントフック',
        abbreviationStandard: 'WAT',
        id: 53,
        enabled: true
    },
    {
        name: 'Asia/Jerusalem',
        displayName: 'GMT+02:00 エルサレム IST',
        nameLocalized: 'エルサレム',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 247,
        enabled: true
    },
    {
        name: 'Africa/Cairo',
        displayName: 'GMT+02:00 カイロ EET',
        nameLocalized: 'カイロ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 14,
        enabled: true
    },
    {
        name: 'Asia/Gaza',
        displayName: 'GMT+02:00 ガザ EET',
        nameLocalized: 'ガザ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 239
    },
    {
        name: 'Europe/Kaliningrad',
        displayName: 'GMT+02:00 カリーニングラード EET',
        nameLocalized: 'カリーニングラード',
        abbreviationStandard: 'EET',
        id: 409
    },
    {
        name: 'Europe/Kiev',
        displayName: 'GMT+02:00 キーウ EET',
        nameLocalized: 'キーウ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 410
    },
    {
        name: 'Africa/Kigali',
        displayName: 'GMT+02:00 キガリ CAT',
        nameLocalized: 'キガリ',
        abbreviationStandard: 'CAT',
        id: 29
    },
    {
        name: 'Europe/Chisinau',
        displayName: 'GMT+02:00 キシナウ EET',
        nameLocalized: 'キシナウ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 400
    },
    {
        name: 'Europe/Sofia',
        displayName: 'GMT+02:00 ソフィア EET',
        nameLocalized: 'ソフィア',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 433
    },
    {
        name: 'Europe/Tallinn',
        displayName: 'GMT+02:00 タリン EET',
        nameLocalized: 'タリン',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 435
    },
    {
        name: 'Africa/Tripoli',
        displayName: 'GMT+02:00 トリポリ EET',
        nameLocalized: 'トリポリ',
        abbreviationStandard: 'EET',
        id: 51
    },
    {
        name: 'Asia/Nicosia',
        displayName: 'GMT+02:00 ニコシア EET',
        nameLocalized: 'ニコシア',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 263
    },
    {
        name: 'Africa/Gaborone',
        displayName: 'GMT+02:00 ハボローネ CAT',
        nameLocalized: 'ハボローネ',
        abbreviationStandard: 'CAT',
        id: 24
    },
    {
        name: 'Africa/Harare',
        displayName: 'GMT+02:00 ハラレ CAT',
        nameLocalized: 'ハラレ',
        abbreviationStandard: 'CAT',
        id: 25,
        enabled: true
    },
    {
        name: 'Africa/Khartoum',
        displayName: 'GMT+02:00 ハルツーム CAT',
        nameLocalized: 'ハルツーム',
        abbreviationStandard: 'CAT',
        id: 28
    },
    {
        name: 'Europe/Bucharest',
        displayName: 'GMT+02:00 ブカレスト EET',
        nameLocalized: 'ブカレスト',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 398
    },
    {
        name: 'Africa/Bujumbura',
        displayName: 'GMT+02:00 ブジュンブラ CAT',
        nameLocalized: 'ブジュンブラ',
        abbreviationStandard: 'CAT',
        id: 13
    },
    {
        name: 'Africa/Blantyre',
        displayName: 'GMT+02:00 ブランタイヤ CAT',
        nameLocalized: 'ブランタイヤ',
        abbreviationStandard: 'CAT',
        id: 11
    },
    {
        name: 'Asia/Beirut',
        displayName: 'GMT+02:00 ベイルート EET',
        nameLocalized: 'ベイルート',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 225,
        enabled: true
    },
    {
        name: 'Europe/Helsinki',
        displayName: 'GMT+02:00 ヘルシンキ EET',
        nameLocalized: 'ヘルシンキ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 405,
        enabled: true
    },
    {
        name: 'Africa/Maseru',
        displayName: 'GMT+02:00 マセル SAST',
        nameLocalized: 'マセル',
        abbreviationStandard: 'SAST',
        id: 39
    },
    {
        name: 'Africa/Maputo',
        displayName: 'GMT+02:00 マプト CAT',
        nameLocalized: 'マプト',
        abbreviationStandard: 'CAT',
        id: 38
    },
    {
        name: 'Europe/Mariehamn',
        displayName: 'GMT+02:00 マリエハムン EET',
        nameLocalized: 'マリエハムン',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 417
    },
    {
        name: 'Africa/Mbabane',
        displayName: 'GMT+02:00 ムババーネ SAST',
        nameLocalized: 'ムババーネ',
        abbreviationStandard: 'SAST',
        id: 40
    },
    {
        name: 'Africa/Johannesburg',
        displayName: 'GMT+02:00 ヨハネスブルグ SAST',
        nameLocalized: 'ヨハネスブルグ',
        abbreviationStandard: 'SAST',
        id: 26
    },
    {
        name: 'Europe/Riga',
        displayName: 'GMT+02:00 リガ EET',
        nameLocalized: 'リガ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 426
    },
    {
        name: 'Africa/Lusaka',
        displayName: 'GMT+02:00 ルサカ CAT',
        nameLocalized: 'ルサカ',
        abbreviationStandard: 'CAT',
        id: 36
    },
    {
        name: 'Africa/Lubumbashi',
        displayName: 'GMT+02:00 ルブンバシ CAT',
        nameLocalized: 'ルブンバシ',
        abbreviationStandard: 'CAT',
        id: 35
    },
    {
        name: 'CET',
        displayName: 'GMT+01:00 CET CET',
        nameLocalized: 'CET',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 345
    },
    {
        name: 'MET',
        displayName: 'GMT+01:00 MET MET',
        nameLocalized: 'MET',
        abbreviationStandard: 'MET',
        abbreviationDaylight: 'MEST',
        id: 476
    },
    {
        name: 'Africa/El_Aaiun',
        displayName: 'GMT+01:00 アイウン +01/+00',
        nameLocalized: 'アイウン',
        abbreviationStandard: '+01/+00',
        id: 22
    },
    {
        name: 'Europe/Amsterdam',
        displayName: 'GMT+01:00 アムステルダム CET',
        nameLocalized: 'アムステルダム',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 390,
        enabled: true
    },
    {
        name: 'Africa/Algiers',
        displayName: 'GMT+01:00 アルジェ CET',
        nameLocalized: 'アルジェ',
        abbreviationStandard: 'CET',
        id: 4
    },
    {
        name: 'Europe/Andorra',
        displayName: 'GMT+01:00 アンドラ CET',
        nameLocalized: 'アンドラ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 391
    },
    {
        name: 'Europe/Vienna',
        displayName: 'GMT+01:00 ウィーン CET',
        nameLocalized: 'ウィーン',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 441
    },
    {
        name: 'Europe/Oslo',
        displayName: 'GMT+01:00 オスロ CET',
        nameLocalized: 'オスロ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 422
    },
    {
        name: 'Africa/Casablanca',
        displayName: 'GMT+01:00 カサブランカ +01/+00',
        nameLocalized: 'カサブランカ',
        abbreviationStandard: '+01/+00',
        id: 15,
        enabled: true
    },
    {
        name: 'Africa/Kinshasa',
        displayName: 'GMT+01:00 キンシャサ WAT',
        nameLocalized: 'キンシャサ',
        abbreviationStandard: 'WAT',
        id: 30
    },
    {
        name: 'Europe/Copenhagen',
        displayName: 'GMT+01:00 コペンハーゲン CET',
        nameLocalized: 'コペンハーゲン',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 401
    },
    {
        name: 'Europe/Zagreb',
        displayName: 'GMT+01:00 ザグレブ CET',
        nameLocalized: 'ザグレブ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 445
    },
    {
        name: 'Europe/Sarajevo',
        displayName: 'GMT+01:00 サラエボ CET',
        nameLocalized: 'サラエボ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 430,
        enabled: true
    },
    {
        name: 'Europe/San_Marino',
        displayName: 'GMT+01:00 サンマリノ CET',
        nameLocalized: 'サンマリノ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 429
    },
    {
        name: 'Europe/Gibraltar',
        displayName: 'GMT+01:00 ジブラルタル CET',
        nameLocalized: 'ジブラルタル',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 403
    },
    {
        name: 'Europe/Skopje',
        displayName: 'GMT+01:00 スコピエ CET',
        nameLocalized: 'スコピエ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 432
    },
    {
        name: 'Europe/Stockholm',
        displayName: 'GMT+01:00 ストックホルム CET',
        nameLocalized: 'ストックホルム',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 434
    },
    {
        name: 'Africa/Ceuta',
        displayName: 'GMT+01:00 セウタ CET',
        nameLocalized: 'セウタ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 16
    },
    {
        name: 'Europe/Dublin',
        displayName: 'GMT+01:00 ダブリン IST/GMT',
        nameLocalized: 'ダブリン',
        abbreviationStandard: 'IST/GMT',
        id: 402
    },
    {
        name: 'Europe/Zurich',
        displayName: 'GMT+01:00 チューリッヒ CET',
        nameLocalized: 'チューリッヒ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 447
    },
    {
        name: 'Africa/Tunis',
        displayName: 'GMT+01:00 チュニス CEST',
        nameLocalized: 'チュニス',
        abbreviationStandard: 'CEST',
        id: 52
    },
    {
        name: 'Europe/Tirane',
        displayName: 'GMT+01:00 ティラナ CET',
        nameLocalized: 'ティラナ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 436
    },
    {
        name: 'Africa/Douala',
        displayName: 'GMT+01:00 ドゥアラ WAT',
        nameLocalized: 'ドゥアラ',
        abbreviationStandard: 'WAT',
        id: 21
    },
    {
        name: 'Africa/Niamey',
        displayName: 'GMT+01:00 ニアメ WAT',
        nameLocalized: 'ニアメ',
        abbreviationStandard: 'WAT',
        id: 45
    },
    {
        name: 'Europe/Vatican',
        displayName: 'GMT+01:00 バチカン CET',
        nameLocalized: 'バチカン',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 440
    },
    {
        name: 'Europe/Paris',
        displayName: 'GMT+01:00 パリ CET',
        nameLocalized: 'パリ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 423
    },
    {
        name: 'Africa/Bangui',
        displayName: 'GMT+01:00 バンギ WAT',
        nameLocalized: 'バンギ',
        abbreviationStandard: 'WAT',
        id: 8
    },
    {
        name: 'Europe/Vaduz',
        displayName: 'GMT+01:00 ファドゥーツ CET',
        nameLocalized: 'ファドゥーツ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 439
    },
    {
        name: 'Europe/Budapest',
        displayName: 'GMT+01:00 ブダペスト CET',
        nameLocalized: 'ブダペスト',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 399,
        enabled: true
    },
    {
        name: 'Africa/Brazzaville',
        displayName: 'GMT+01:00 ブラザビル WAT',
        nameLocalized: 'ブラザビル',
        abbreviationStandard: 'WAT',
        id: 12
    },
    {
        name: 'Europe/Bratislava',
        displayName: 'GMT+01:00 ブラチスラバ CET',
        nameLocalized: 'ブラチスラバ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 396
    },
    {
        name: 'Europe/Prague',
        displayName: 'GMT+01:00 プラハ CET',
        nameLocalized: 'プラハ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 425
    },
    {
        name: 'Europe/Brussels',
        displayName: 'GMT+01:00 ブリュッセル CET',
        nameLocalized: 'ブリュッセル',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 397
    },
    {
        name: 'Europe/Belgrade',
        displayName: 'GMT+01:00 ベオグラード CET',
        nameLocalized: 'ベオグラード',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 394
    },
    {
        name: 'Europe/Berlin',
        displayName: 'GMT+01:00 ベルリン CET',
        nameLocalized: 'ベルリン',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 395
    },
    {
        name: 'Europe/Podgorica',
        displayName: 'GMT+01:00 ポドゴリツァ CET',
        nameLocalized: 'ポドゴリツァ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 424
    },
    {
        name: 'Africa/Porto-Novo',
        displayName: 'GMT+01:00 ポルトノボ WAT',
        nameLocalized: 'ポルトノボ',
        abbreviationStandard: 'WAT',
        id: 48,
        enabled: true
    },
    {
        name: 'Europe/Madrid',
        displayName: 'GMT+01:00 マドリード CET',
        nameLocalized: 'マドリード',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 415,
        enabled: true
    },
    {
        name: 'Africa/Malabo',
        displayName: 'GMT+01:00 マラボ WAT',
        nameLocalized: 'マラボ',
        abbreviationStandard: 'WAT',
        id: 37
    },
    {
        name: 'Europe/Malta',
        displayName: 'GMT+01:00 マルタ CET',
        nameLocalized: 'マルタ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 416
    },
    {
        name: 'Europe/Monaco',
        displayName: 'GMT+01:00 モナコ CET',
        nameLocalized: 'モナコ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 419
    },
    {
        name: 'Africa/Lagos',
        displayName: 'GMT+01:00 ラゴス WAT',
        nameLocalized: 'ラゴス',
        abbreviationStandard: 'WAT',
        id: 31
    },
    {
        name: 'Africa/Libreville',
        displayName: 'GMT+01:00 リーブルヴィル WAT',
        nameLocalized: 'リーブルヴィル',
        abbreviationStandard: 'WAT',
        id: 32
    },
    {
        name: 'Europe/Ljubljana',
        displayName: 'GMT+01:00 リュブリャナ CET',
        nameLocalized: 'リュブリャナ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 412
    },
    {
        name: 'Africa/Luanda',
        displayName: 'GMT+01:00 ルアンダ WAT',
        nameLocalized: 'ルアンダ',
        abbreviationStandard: 'WAT',
        id: 34
    },
    {
        name: 'Europe/Luxembourg',
        displayName: 'GMT+01:00 ルクセンブルク CET',
        nameLocalized: 'ルクセンブルク',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 414
    },
    {
        name: 'Europe/Rome',
        displayName: 'GMT+01:00 ローマ CET',
        nameLocalized: 'ローマ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 427
    },
    {
        name: 'Arctic/Longyearbyen',
        displayName: 'GMT+01:00 ロングイェールビーン CET',
        nameLocalized: 'ロングイェールビーン',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 212
    },
    {
        name: 'Europe/Warsaw',
        displayName: 'GMT+01:00 ワルシャワ CET',
        nameLocalized: 'ワルシャワ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 444
    },
    {
        name: 'Africa/Ndjamena',
        displayName: 'GMT+01:00 ンジャメナ WAT',
        nameLocalized: 'ンジャメナ',
        abbreviationStandard: 'WAT',
        id: 44
    },
    {
        name: 'US/Aleutian',
        displayName: 'GMT+00:00 Aleutian UTC',
        nameLocalized: 'Aleutian',
        abbreviationStandard: 'UTC',
        id: 536
    },
    {
        name: 'US/Arizona',
        displayName: 'GMT+00:00 Arizona UTC',
        nameLocalized: 'Arizona',
        abbreviationStandard: 'UTC',
        id: 537
    },
    {
        name: 'Asia/Ashkhabad',
        displayName: 'GMT+00:00 Ashkhabad UTC',
        nameLocalized: 'Ashkhabad',
        abbreviationStandard: 'UTC',
        id: 220
    },
    {
        name: 'America/Atka',
        displayName: 'GMT+00:00 Atka UTC',
        nameLocalized: 'Atka',
        abbreviationStandard: 'UTC',
        id: 73
    },
    {
        name: 'Canada/Atlantic',
        displayName: 'GMT+00:00 Atlantic UTC',
        nameLocalized: 'Atlantic',
        abbreviationStandard: 'UTC',
        id: 336
    },
    {
        name: 'Mexico/BajaNorte',
        displayName: 'GMT+00:00 BajaNorte UTC',
        nameLocalized: 'BajaNorte',
        abbreviationStandard: 'UTC',
        id: 477
    },
    {
        name: 'Europe/Belfast',
        displayName: 'GMT+00:00 Belfast GMT/BST',
        nameLocalized: 'Belfast',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 393
    },
    {
        name: 'US/Central',
        displayName: 'GMT+00:00 Central UTC',
        nameLocalized: 'Central',
        abbreviationStandard: 'UTC',
        id: 538
    },
    {
        name: 'Cuba',
        displayName: 'GMT+00:00 Cuba UTC',
        nameLocalized: 'Cuba',
        abbreviationStandard: 'UTC',
        id: 349
    },
    {
        name: 'Asia/Dacca',
        displayName: 'GMT+00:00 Dacca UTC',
        nameLocalized: 'Dacca',
        abbreviationStandard: 'UTC',
        id: 233
    },
    {
        name: 'Brazil/DeNoronha',
        displayName: 'GMT+00:00 DeNoronha UTC',
        nameLocalized: 'DeNoronha',
        abbreviationStandard: 'UTC',
        id: 333
    },
    {
        name: 'Canada/East-Saskatchewan',
        displayName: 'GMT+00:00 East-Saskatchewan UTC',
        nameLocalized: 'East-Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 338
    },
    {
        name: 'Chile/EasterIsland',
        displayName: 'GMT+00:00 EasterIsland UTC',
        nameLocalized: 'EasterIsland',
        abbreviationStandard: 'UTC',
        id: 347
    },
    {
        name: 'Canada/Eastern',
        displayName: 'GMT+00:00 Eastern UTC',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'UTC',
        id: 339
    },
    {
        name: 'Egypt',
        displayName: 'GMT+00:00 Egypt UTC',
        nameLocalized: 'Egypt',
        abbreviationStandard: 'UTC',
        id: 351
    },
    {
        name: 'Eire',
        displayName: 'GMT+00:00 Eire UTC',
        nameLocalized: 'Eire',
        abbreviationStandard: 'UTC',
        id: 352
    },
    {
        name: 'Factory',
        displayName: 'GMT+00:00 Factory -00',
        nameLocalized: 'Factory',
        abbreviationStandard: '-00',
        id: 448
    },
    {
        name: 'Atlantic/Faroe',
        displayName: 'GMT+00:00 Faroe WET',
        nameLocalized: 'Faroe',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 302
    },
    {
        name: 'GB',
        displayName: 'GMT+00:00 GB UTC',
        nameLocalized: 'GB',
        abbreviationStandard: 'UTC',
        id: 449
    },
    {
        name: 'GB-Eire',
        displayName: 'GMT+00:00 GB-Eire UTC',
        nameLocalized: 'GB-Eire',
        abbreviationStandard: 'UTC',
        id: 450
    },
    {
        name: 'Etc/GMT',
        displayName: 'GMT+00:00 GMT GMT',
        nameLocalized: 'GMT',
        abbreviationStandard: 'GMT',
        id: 355
    },
    {
        name: 'GMT',
        displayName: 'GMT+00:00 GMT UTC',
        nameLocalized: 'GMT',
        abbreviationStandard: 'UTC',
        id: 451
    },
    {
        name: 'Etc/GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 369
    },
    {
        name: 'GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 453
    },
    {
        name: 'Etc/GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 356
    },
    {
        name: 'GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 452
    },
    {
        name: 'Etc/GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 384
    },
    {
        name: 'GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 454
    },
    {
        name: 'Etc/Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 385
    },
    {
        name: 'Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 455
    },
    {
        name: 'Hongkong',
        displayName: 'GMT+00:00 Hongkong UTC',
        nameLocalized: 'Hongkong',
        abbreviationStandard: 'UTC',
        id: 456
    },
    {
        name: 'Iceland',
        displayName: 'GMT+00:00 Iceland GMT',
        nameLocalized: 'Iceland',
        abbreviationStandard: 'GMT',
        id: 458
    },
    {
        name: 'Iran',
        displayName: 'GMT+00:00 Iran UTC',
        nameLocalized: 'Iran',
        abbreviationStandard: 'UTC',
        id: 470
    },
    {
        name: 'Israel',
        displayName: 'GMT+00:00 Israel UTC',
        nameLocalized: 'Israel',
        abbreviationStandard: 'UTC',
        id: 471
    },
    {
        name: 'Jamaica',
        displayName: 'GMT+00:00 Jamaica UTC',
        nameLocalized: 'Jamaica',
        abbreviationStandard: 'UTC',
        id: 472
    },
    {
        name: 'Japan',
        displayName: 'GMT+00:00 Japan UTC',
        nameLocalized: 'Japan',
        abbreviationStandard: 'UTC',
        id: 473
    },
    {
        name: 'Libya',
        displayName: 'GMT+00:00 Libya UTC',
        nameLocalized: 'Libya',
        abbreviationStandard: 'UTC',
        id: 475
    },
    {
        name: 'Asia/Macao',
        displayName: 'GMT+00:00 Macao UTC',
        nameLocalized: 'Macao',
        abbreviationStandard: 'UTC',
        id: 257
    },
    {
        name: 'US/Michigan',
        displayName: 'GMT+00:00 Michigan UTC',
        nameLocalized: 'Michigan',
        abbreviationStandard: 'UTC',
        id: 543
    },
    {
        name: 'US/Mountain',
        displayName: 'GMT+00:00 Mountain UTC',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'UTC',
        id: 544
    },
    {
        name: 'Navajo',
        displayName: 'GMT+00:00 Navajo UTC',
        nameLocalized: 'Navajo',
        abbreviationStandard: 'UTC',
        id: 482
    },
    {
        name: 'NZ-CHAT',
        displayName: 'GMT+00:00 NZ-CHAT UTC',
        nameLocalized: 'NZ-CHAT',
        abbreviationStandard: 'UTC',
        id: 484
    },
    {
        name: 'US/Pacific-New',
        displayName: 'GMT+00:00 Pacific-New UTC',
        nameLocalized: 'Pacific-New',
        abbreviationStandard: 'UTC',
        id: 546
    },
    {
        name: 'Poland',
        displayName: 'GMT+00:00 Poland UTC',
        nameLocalized: 'Poland',
        abbreviationStandard: 'UTC',
        id: 525
    },
    {
        name: 'Portugal',
        displayName: 'GMT+00:00 Portugal UTC',
        nameLocalized: 'Portugal',
        abbreviationStandard: 'UTC',
        id: 526
    },
    {
        name: 'PRC',
        displayName: 'GMT+00:00 PRC UTC',
        nameLocalized: 'PRC',
        abbreviationStandard: 'UTC',
        id: 527
    },
    {
        name: 'ROC',
        displayName: 'GMT+00:00 ROC UTC',
        nameLocalized: 'ROC',
        abbreviationStandard: 'UTC',
        id: 529
    },
    {
        name: 'ROK',
        displayName: 'GMT+00:00 ROK UTC',
        nameLocalized: 'ROK',
        abbreviationStandard: 'UTC',
        id: 530
    },
    {
        name: 'Canada/Saskatchewan',
        displayName: 'GMT+00:00 Saskatchewan UTC',
        nameLocalized: 'Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 343,
        enabled: true
    },
    {
        name: 'America/Shiprock',
        displayName: 'GMT+00:00 Shiprock UTC',
        nameLocalized: 'Shiprock',
        abbreviationStandard: 'UTC',
        id: 183
    },
    {
        name: 'Singapore',
        displayName: 'GMT+00:00 Singapore UTC',
        nameLocalized: 'Singapore',
        abbreviationStandard: 'UTC',
        id: 531
    },
    {
        name: 'Asia/Thimbu',
        displayName: 'GMT+00:00 Thimbu UTC',
        nameLocalized: 'Thimbu',
        abbreviationStandard: 'UTC',
        id: 285
    },
    {
        name: 'Africa/Timbuktu',
        displayName: 'GMT+00:00 Timbuktu GMT',
        nameLocalized: 'Timbuktu',
        abbreviationStandard: 'GMT',
        id: 50
    },
    {
        name: 'Turkey',
        displayName: 'GMT+00:00 Turkey UTC',
        nameLocalized: 'Turkey',
        abbreviationStandard: 'UTC',
        id: 532
    },
    {
        name: 'Etc/UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 386
    },
    {
        name: 'UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 533
    },
    {
        name: 'Asia/Ujung_Pandang',
        displayName: 'GMT+00:00 Ujung Pandang UTC',
        nameLocalized: 'Ujung Pandang',
        abbreviationStandard: 'UTC',
        id: 288
    },
    {
        name: 'Etc/Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 387
    },
    {
        name: 'Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 534
    },
    {
        name: 'Etc/UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 388
    },
    {
        name: 'UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 548
    },
    {
        name: 'W-SU',
        displayName: 'GMT+00:00 W-SU UTC',
        nameLocalized: 'W-SU',
        abbreviationStandard: 'UTC',
        id: 549
    },
    {
        name: 'Australia/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 330
    },
    {
        name: 'Brazil/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 335
    },
    {
        name: 'WET',
        displayName: 'GMT+00:00 WET WET',
        nameLocalized: 'WET',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 550
    },
    {
        name: 'Etc/Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 389
    },
    {
        name: 'Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 551,
        enabled: true
    },
    {
        name: 'Africa/Accra',
        displayName: 'GMT+00:00 アクラ GMT',
        nameLocalized: 'アクラ',
        abbreviationStandard: 'GMT',
        id: 2
    },
    {
        name: 'Africa/Abidjan',
        displayName: 'GMT+00:00 アビジャン GMT',
        nameLocalized: 'アビジャン',
        abbreviationStandard: 'GMT',
        id: 1
    },
    {
        name: 'Pacific/Enderbury',
        displayName: 'GMT+00:00 エンダーベリー島 -00',
        nameLocalized: 'エンダーベリー島',
        abbreviationStandard: '-00',
        id: 490
    },
    {
        name: 'Europe/Guernsey',
        displayName: 'GMT+00:00 ガーンジー GMT/BST',
        nameLocalized: 'ガーンジー',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 404
    },
    {
        name: 'Asia/Katmandu',
        displayName: 'GMT+00:00 カトマンズ UTC',
        nameLocalized: 'カトマンズ',
        abbreviationStandard: 'UTC',
        id: 252,
        enabled: true
    },
    {
        name: 'Atlantic/Canary',
        displayName: 'GMT+00:00 カナリア WET',
        nameLocalized: 'カナリア',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 299
    },
    {
        name: 'Africa/Conakry',
        displayName: 'GMT+00:00 コナクリ GMT',
        nameLocalized: 'コナクリ',
        abbreviationStandard: 'GMT',
        id: 17
    },
    {
        name: 'Asia/Calcutta',
        displayName: 'GMT+00:00 コルカタ UTC',
        nameLocalized: 'コルカタ',
        abbreviationStandard: 'UTC',
        id: 228,
        enabled: true
    },
    {
        name: 'Africa/Sao_Tome',
        displayName: 'GMT+00:00 サントメ GMT',
        nameLocalized: 'サントメ',
        abbreviationStandard: 'GMT',
        id: 49
    },
    {
        name: 'Europe/Jersey',
        displayName: 'GMT+00:00 ジャージー GMT/BST',
        nameLocalized: 'ジャージー',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 408
    },
    {
        name: 'Atlantic/St_Helena',
        displayName: 'GMT+00:00 セントヘレナ GMT',
        nameLocalized: 'セントヘレナ',
        abbreviationStandard: 'GMT',
        id: 307
    },
    {
        name: 'Africa/Dakar',
        displayName: 'GMT+00:00 ダカール GMT',
        nameLocalized: 'ダカール',
        abbreviationStandard: 'GMT',
        id: 18
    },
    {
        name: 'America/Danmarkshavn',
        displayName: 'GMT+00:00 デンマークシャウン GMT',
        nameLocalized: 'デンマークシャウン',
        abbreviationStandard: 'GMT',
        id: 97
    },
    {
        name: 'Africa/Nouakchott',
        displayName: 'GMT+00:00 ヌアクショット GMT',
        nameLocalized: 'ヌアクショット',
        abbreviationStandard: 'GMT',
        id: 46
    },
    {
        name: 'Africa/Bamako',
        displayName: 'GMT+00:00 バマコ GMT',
        nameLocalized: 'バマコ',
        abbreviationStandard: 'GMT',
        id: 7
    },
    {
        name: 'Africa/Banjul',
        displayName: 'GMT+00:00 バンジュール GMT',
        nameLocalized: 'バンジュール',
        abbreviationStandard: 'GMT',
        id: 9
    },
    {
        name: 'Africa/Bissau',
        displayName: 'GMT+00:00 ビサウ GMT',
        nameLocalized: 'ビサウ',
        abbreviationStandard: 'GMT',
        id: 10
    },
    {
        name: 'Atlantic/Faeroe',
        displayName: 'GMT+00:00 フェロー UTC',
        nameLocalized: 'フェロー',
        abbreviationStandard: 'UTC',
        id: 301
    },
    {
        name: 'Africa/Freetown',
        displayName: 'GMT+00:00 フリータウン GMT',
        nameLocalized: 'フリータウン',
        abbreviationStandard: 'GMT',
        id: 23
    },
    {
        name: 'Atlantic/Madeira',
        displayName: 'GMT+00:00 マデイラ WET',
        nameLocalized: 'マデイラ',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 304
    },
    {
        name: 'Europe/Isle_of_Man',
        displayName: 'GMT+00:00 マン島 GMT/BST',
        nameLocalized: 'マン島',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 406
    },
    {
        name: 'Africa/Monrovia',
        displayName: 'GMT+00:00 モンロビア GMT',
        nameLocalized: 'モンロビア',
        abbreviationStandard: 'GMT',
        id: 42
    },
    {
        name: 'Asia/Rangoon',
        displayName: 'GMT+00:00 ヤンゴン UTC',
        nameLocalized: 'ヤンゴン',
        abbreviationStandard: 'UTC',
        id: 272,
        enabled: true
    },
    {
        name: 'Europe/Lisbon',
        displayName: 'GMT+00:00 リスボン WET',
        nameLocalized: 'リスボン',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 411
    },
    {
        name: 'Atlantic/Reykjavik',
        displayName: 'GMT+00:00 レイキャビク GMT',
        nameLocalized: 'レイキャビク',
        abbreviationStandard: 'GMT',
        id: 305
    },
    {
        name: 'Africa/Lome',
        displayName: 'GMT+00:00 ロメ GMT',
        nameLocalized: 'ロメ',
        abbreviationStandard: 'GMT',
        id: 33
    },
    {
        name: 'Europe/London',
        displayName: 'GMT+00:00 ロンドン GMT/BST',
        nameLocalized: 'ロンドン',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 413,
        enabled: true
    },
    {
        name: 'Africa/Ouagadougou',
        displayName: 'GMT+00:00 ワガドゥグー GMT',
        nameLocalized: 'ワガドゥグー',
        abbreviationStandard: 'GMT',
        id: 47
    },
    {
        name: 'Etc/GMT-1',
        displayName: 'GMT-01:00 GMT-1 -01',
        nameLocalized: 'GMT-1',
        abbreviationStandard: '-01',
        id: 370
    },
    {
        name: 'Etc/GMT+1',
        displayName: 'GMT-01:00 GMT+1 -01',
        nameLocalized: 'GMT+1',
        abbreviationStandard: '-01',
        id: 357
    },
    {
        name: 'Atlantic/Jan_Mayen',
        displayName: 'GMT-01:00 Jan Mayen -01',
        nameLocalized: 'Jan Mayen',
        abbreviationStandard: '-01',
        id: 303
    },
    {
        name: 'Atlantic/Azores',
        displayName: 'GMT-01:00 アゾレス -01/+00',
        nameLocalized: 'アゾレス',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 297,
        enabled: true
    },
    {
        name: 'Atlantic/Cape_Verde',
        displayName: 'GMT-01:00 カーボベルデ -01',
        nameLocalized: 'カーボベルデ',
        abbreviationStandard: '-01',
        id: 300,
        enabled: true
    },
    {
        name: 'Etc/GMT-2',
        displayName: 'GMT-02:00 GMT-2 -02',
        nameLocalized: 'GMT-2',
        abbreviationStandard: '-02',
        id: 376
    },
    {
        name: 'Etc/GMT+2',
        displayName: 'GMT-02:00 GMT+2 -02',
        nameLocalized: 'GMT+2',
        abbreviationStandard: '-02',
        id: 361
    },
    {
        name: 'America/Scoresbysund',
        displayName: 'GMT-02:00 イトコルトルミット -02/-01',
        nameLocalized: 'イトコルトルミット',
        abbreviationStandard: '-02/-01',
        abbreviationDaylight: '-02/-01',
        id: 182
    },
    {
        name: 'Atlantic/South_Georgia',
        displayName: 'GMT-02:00 サウスジョージア -02',
        nameLocalized: 'サウスジョージア',
        abbreviationStandard: '-02',
        id: 306,
        enabled: true
    },
    {
        name: 'America/Noronha',
        displayName: 'GMT-02:00 ノローニャ -02',
        nameLocalized: 'ノローニャ',
        abbreviationStandard: '-02',
        id: 160
    },
    {
        name: 'Canada/Newfoundland',
        displayName: 'GMT-03:30 Newfoundland NST',
        nameLocalized: 'Newfoundland',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 341
    },
    {
        name: 'America/St_Johns',
        displayName: 'GMT-03:30 セントジョンズ NST',
        nameLocalized: 'セントジョンズ',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 184,
        enabled: true
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        displayName: 'GMT-03:00 Buenos Aires -03/-02',
        nameLocalized: 'Buenos Aires',
        abbreviationStandard: '-03/-02',
        id: 59
    },
    {
        name: 'America/Argentina/Catamarca',
        displayName: 'GMT-03:00 Catamarca -03',
        nameLocalized: 'Catamarca',
        abbreviationStandard: '-03',
        id: 60
    },
    {
        name: 'America/Argentina/ComodRivadavia',
        displayName: 'GMT-03:00 ComodRivadavia -03',
        nameLocalized: 'ComodRivadavia',
        abbreviationStandard: '-03',
        id: 61
    },
    {
        name: 'America/Argentina/Cordoba',
        displayName: 'GMT-03:00 Cordoba -03/-02',
        nameLocalized: 'Cordoba',
        abbreviationStandard: '-03/-02',
        id: 62
    },
    {
        name: 'Brazil/East',
        displayName: 'GMT-03:00 East -03/-02',
        nameLocalized: 'East',
        abbreviationStandard: '-03/-02',
        id: 334
    },
    {
        name: 'Etc/GMT-3',
        displayName: 'GMT-03:00 GMT-3 -03',
        nameLocalized: 'GMT-3',
        abbreviationStandard: '-03',
        id: 377
    },
    {
        name: 'Etc/GMT+3',
        displayName: 'GMT-03:00 GMT+3 -03',
        nameLocalized: 'GMT+3',
        abbreviationStandard: '-03',
        id: 362
    },
    {
        name: 'America/Argentina/Jujuy',
        displayName: 'GMT-03:00 Jujuy -03',
        nameLocalized: 'Jujuy',
        abbreviationStandard: '-03',
        id: 63
    },
    {
        name: 'America/Argentina/Mendoza',
        displayName: 'GMT-03:00 Mendoza -03',
        nameLocalized: 'Mendoza',
        abbreviationStandard: '-03',
        id: 65
    },
    {
        name: 'America/Rosario',
        displayName: 'GMT-03:00 Rosario -03/-02',
        nameLocalized: 'Rosario',
        abbreviationStandard: '-03/-02',
        id: 178
    },
    {
        name: 'America/Araguaina',
        displayName: 'GMT-03:00 アラグァイナ -03',
        nameLocalized: 'アラグァイナ',
        abbreviationStandard: '-03',
        id: 58
    },
    {
        name: 'America/Argentina/Ushuaia',
        displayName: 'GMT-03:00 ウシュアイア -03',
        nameLocalized: 'ウシュアイア',
        abbreviationStandard: '-03',
        id: 69
    },
    {
        name: 'America/Cayenne',
        displayName: 'GMT-03:00 カイエンヌ -03',
        nameLocalized: 'カイエンヌ',
        abbreviationStandard: '-03',
        id: 88
    },
    {
        name: 'America/Catamarca',
        displayName: 'GMT-03:00 カタマルカ -03',
        nameLocalized: 'カタマルカ',
        abbreviationStandard: '-03',
        id: 87
    },
    {
        name: 'America/Cordoba',
        displayName: 'GMT-03:00 コルドバ -03/-02',
        nameLocalized: 'コルドバ',
        abbreviationStandard: '-03/-02',
        id: 93
    },
    {
        name: 'America/Sao_Paulo',
        displayName: 'GMT-03:00 サンパウロ -03/-02',
        nameLocalized: 'サンパウロ',
        abbreviationStandard: '-03/-02',
        id: 181,
        enabled: true
    },
    {
        name: 'America/Argentina/San_Juan',
        displayName: 'GMT-03:00 サンファン -03',
        nameLocalized: 'サンファン',
        abbreviationStandard: '-03',
        id: 67
    },
    {
        name: 'Atlantic/Stanley',
        displayName: 'GMT-03:00 スタンレー -03',
        nameLocalized: 'スタンレー',
        abbreviationStandard: '-03',
        id: 308
    },
    {
        name: 'America/Argentina/Tucuman',
        displayName: 'GMT-03:00 トゥクマン -03/-02',
        nameLocalized: 'トゥクマン',
        abbreviationStandard: '-03/-02',
        id: 68
    },
    {
        name: 'America/Godthab',
        displayName: 'GMT-03:00 ヌーク -03/-02',
        nameLocalized: 'ヌーク',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 110,
        enabled: true
    },
    {
        name: 'Antarctica/Palmer',
        displayName: 'GMT-03:00 パーマー基地 -03',
        nameLocalized: 'パーマー基地',
        abbreviationStandard: '-03',
        id: 207
    },
    {
        name: 'America/Bahia',
        displayName: 'GMT-03:00 バイーア -03',
        nameLocalized: 'バイーア',
        abbreviationStandard: '-03',
        id: 74
    },
    {
        name: 'America/Paramaribo',
        displayName: 'GMT-03:00 パラマリボ -03',
        nameLocalized: 'パラマリボ',
        abbreviationStandard: '-03',
        id: 165
    },
    {
        name: 'America/Buenos_Aires',
        displayName: 'GMT-03:00 ブエノスアイレス -03/-02',
        nameLocalized: 'ブエノスアイレス',
        abbreviationStandard: '-03/-02',
        id: 82,
        enabled: true
    },
    {
        name: 'America/Fortaleza',
        displayName: 'GMT-03:00 フォルタレザ -03',
        nameLocalized: 'フォルタレザ',
        abbreviationStandard: '-03',
        id: 108
    },
    {
        name: 'America/Jujuy',
        displayName: 'GMT-03:00 フフイ -03',
        nameLocalized: 'フフイ',
        abbreviationStandard: '-03',
        id: 132
    },
    {
        name: 'America/Belem',
        displayName: 'GMT-03:00 ベレン -03',
        nameLocalized: 'ベレン',
        abbreviationStandard: '-03',
        id: 76
    },
    {
        name: 'America/Maceio',
        displayName: 'GMT-03:00 マセイオ -03',
        nameLocalized: 'マセイオ',
        abbreviationStandard: '-03',
        id: 141
    },
    {
        name: 'America/Miquelon',
        displayName: 'GMT-03:00 ミクロン島 -03/-02',
        nameLocalized: 'ミクロン島',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 150
    },
    {
        name: 'America/Mendoza',
        displayName: 'GMT-03:00 メンドーサ -03',
        nameLocalized: 'メンドーサ',
        abbreviationStandard: '-03',
        id: 146
    },
    {
        name: 'America/Montevideo',
        displayName: 'GMT-03:00 モンテビデオ -03/-02',
        nameLocalized: 'モンテビデオ',
        abbreviationStandard: '-03/-02',
        id: 153,
        enabled: true
    },
    {
        name: 'America/Argentina/La_Rioja',
        displayName: 'GMT-03:00 ラリオハ -03',
        nameLocalized: 'ラリオハ',
        abbreviationStandard: '-03',
        id: 64
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        displayName: 'GMT-03:00 リオガジェゴス -03',
        nameLocalized: 'リオガジェゴス',
        abbreviationStandard: '-03',
        id: 66
    },
    {
        name: 'America/Recife',
        displayName: 'GMT-03:00 レシフェ -03',
        nameLocalized: 'レシフェ',
        abbreviationStandard: '-03',
        id: 174
    },
    {
        name: 'Antarctica/Rothera',
        displayName: 'GMT-03:00 ロゼラ基地 -03',
        nameLocalized: 'ロゼラ基地',
        abbreviationStandard: '-03',
        id: 208
    },
    {
        name: 'Chile/Continental',
        displayName: 'GMT-04:00 Continental -04/-03',
        nameLocalized: 'Continental',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 346
    },
    {
        name: 'Etc/GMT-4',
        displayName: 'GMT-04:00 GMT-4 -04',
        nameLocalized: 'GMT-4',
        abbreviationStandard: '-04',
        id: 378
    },
    {
        name: 'Etc/GMT+4',
        displayName: 'GMT-04:00 GMT+4 -04',
        nameLocalized: 'GMT+4',
        abbreviationStandard: '-04',
        id: 363
    },
    {
        name: 'America/Virgin',
        displayName: 'GMT-04:00 Virgin AST',
        nameLocalized: 'Virgin',
        abbreviationStandard: 'AST',
        id: 197
    },
    {
        name: 'America/Asuncion',
        displayName: 'GMT-04:00 アスンシオン -04/-03',
        nameLocalized: 'アスンシオン',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 71
    },
    {
        name: 'America/Aruba',
        displayName: 'GMT-04:00 アルバ AST',
        nameLocalized: 'アルバ',
        abbreviationStandard: 'AST',
        id: 70
    },
    {
        name: 'America/Anguilla',
        displayName: 'GMT-04:00 アンギラ AST',
        nameLocalized: 'アンギラ',
        abbreviationStandard: 'AST',
        id: 56
    },
    {
        name: 'America/Antigua',
        displayName: 'GMT-04:00 アンティグア AST',
        nameLocalized: 'アンティグア',
        abbreviationStandard: 'AST',
        id: 57
    },
    {
        name: 'America/Guyana',
        displayName: 'GMT-04:00 ガイアナ -04',
        nameLocalized: 'ガイアナ',
        abbreviationStandard: '-04',
        id: 117
    },
    {
        name: 'America/Caracas',
        displayName: 'GMT-04:00 カラカス -04',
        nameLocalized: 'カラカス',
        abbreviationStandard: '-04',
        id: 86,
        enabled: true
    },
    {
        name: 'America/Campo_Grande',
        displayName: 'GMT-04:00 カンポグランデ -04/-03',
        nameLocalized: 'カンポグランデ',
        abbreviationStandard: '-04/-03',
        id: 84
    },
    {
        name: 'America/Curacao',
        displayName: 'GMT-04:00 キュラソー AST',
        nameLocalized: 'キュラソー',
        abbreviationStandard: 'AST',
        id: 96
    },
    {
        name: 'America/Guadeloupe',
        displayName: 'GMT-04:00 グアドループ AST',
        nameLocalized: 'グアドループ',
        abbreviationStandard: 'AST',
        id: 114
    },
    {
        name: 'America/Cuiaba',
        displayName: 'GMT-04:00 クイアバ -04/-03',
        nameLocalized: 'クイアバ',
        abbreviationStandard: '-04/-03',
        id: 95
    },
    {
        name: 'America/Goose_Bay',
        displayName: 'GMT-04:00 グースベイ AST',
        nameLocalized: 'グースベイ',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 111,
        enabled: true
    },
    {
        name: 'America/Glace_Bay',
        displayName: 'GMT-04:00 グレースベイ AST',
        nameLocalized: 'グレースベイ',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 109
    },
    {
        name: 'America/Grenada',
        displayName: 'GMT-04:00 グレナダ AST',
        nameLocalized: 'グレナダ',
        abbreviationStandard: 'AST',
        id: 113
    },
    {
        name: 'America/Santiago',
        displayName: 'GMT-04:00 サンチアゴ -04/-03',
        nameLocalized: 'サンチアゴ',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 179,
        enabled: true
    },
    {
        name: 'America/Santo_Domingo',
        displayName: 'GMT-04:00 サントドミンゴ AST',
        nameLocalized: 'サントドミンゴ',
        abbreviationStandard: 'AST',
        id: 180
    },
    {
        name: 'America/St_Kitts',
        displayName: 'GMT-04:00 セントクリストファー AST',
        nameLocalized: 'セントクリストファー',
        abbreviationStandard: 'AST',
        id: 185
    },
    {
        name: 'America/St_Thomas',
        displayName: 'GMT-04:00 セントトーマス AST',
        nameLocalized: 'セントトーマス',
        abbreviationStandard: 'AST',
        id: 187
    },
    {
        name: 'America/St_Vincent',
        displayName: 'GMT-04:00 セントビンセント AST',
        nameLocalized: 'セントビンセント',
        abbreviationStandard: 'AST',
        id: 188
    },
    {
        name: 'America/St_Lucia',
        displayName: 'GMT-04:00 セントルシア AST',
        nameLocalized: 'セントルシア',
        abbreviationStandard: 'AST',
        id: 186
    },
    {
        name: 'America/Thule',
        displayName: 'GMT-04:00 チューレ AST',
        nameLocalized: 'チューレ',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 191
    },
    {
        name: 'America/Dominica',
        displayName: 'GMT-04:00 ドミニカ AST',
        nameLocalized: 'ドミニカ',
        abbreviationStandard: 'AST',
        id: 102
    },
    {
        name: 'America/Tortola',
        displayName: 'GMT-04:00 トルトーラ AST',
        nameLocalized: 'トルトーラ',
        abbreviationStandard: 'AST',
        id: 195
    },
    {
        name: 'Atlantic/Bermuda',
        displayName: 'GMT-04:00 バミューダ AST',
        nameLocalized: 'バミューダ',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 298
    },
    {
        name: 'America/Halifax',
        displayName: 'GMT-04:00 ハリファクス AST',
        nameLocalized: 'ハリファクス',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 118
    },
    {
        name: 'America/Barbados',
        displayName: 'GMT-04:00 バルバドス AST',
        nameLocalized: 'バルバドス',
        abbreviationStandard: 'AST',
        id: 75
    },
    {
        name: 'America/Puerto_Rico',
        displayName: 'GMT-04:00 プエルトリコ AST',
        nameLocalized: 'プエルトリコ',
        abbreviationStandard: 'AST',
        id: 171
    },
    {
        name: 'America/Blanc-Sablon',
        displayName: 'GMT-04:00 ブラン・サブロン AST',
        nameLocalized: 'ブラン・サブロン',
        abbreviationStandard: 'AST',
        id: 78
    },
    {
        name: 'America/Boa_Vista',
        displayName: 'GMT-04:00 ボアビスタ -04',
        nameLocalized: 'ボアビスタ',
        abbreviationStandard: '-04',
        id: 79
    },
    {
        name: 'America/Port_of_Spain',
        displayName: 'GMT-04:00 ポートオブスペイン AST',
        nameLocalized: 'ポートオブスペイン',
        abbreviationStandard: 'AST',
        id: 168
    },
    {
        name: 'America/Porto_Velho',
        displayName: 'GMT-04:00 ポルトベーリョ -04',
        nameLocalized: 'ポルトベーリョ',
        abbreviationStandard: '-04',
        id: 170
    },
    {
        name: 'America/Manaus',
        displayName: 'GMT-04:00 マナウス -04',
        nameLocalized: 'マナウス',
        abbreviationStandard: '-04',
        id: 143,
        enabled: true
    },
    {
        name: 'America/Martinique',
        displayName: 'GMT-04:00 マルティニーク AST',
        nameLocalized: 'マルティニーク',
        abbreviationStandard: 'AST',
        id: 144
    },
    {
        name: 'America/Moncton',
        displayName: 'GMT-04:00 モンクトン AST',
        nameLocalized: 'モンクトン',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 151
    },
    {
        name: 'America/Montserrat',
        displayName: 'GMT-04:00 モントセラト AST',
        nameLocalized: 'モントセラト',
        abbreviationStandard: 'AST',
        id: 155
    },
    {
        name: 'America/La_Paz',
        displayName: 'GMT-04:00 ラパス -04',
        nameLocalized: 'ラパス',
        abbreviationStandard: '-04',
        id: 137,
        enabled: true
    },
    {
        name: 'Brazil/Acre',
        displayName: 'GMT-05:00 Acre -05',
        nameLocalized: 'Acre',
        abbreviationStandard: '-05',
        id: 332
    },
    {
        name: 'America/Atikokan',
        displayName: 'GMT-05:00 Atikokan EST',
        nameLocalized: 'Atikokan',
        abbreviationStandard: 'EST',
        id: 72
    },
    {
        name: 'US/East-Indiana',
        displayName: 'GMT-05:00 East-Indiana EST',
        nameLocalized: 'East-Indiana',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 539
    },
    {
        name: 'US/Eastern',
        displayName: 'GMT-05:00 Eastern EST',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 540
    },
    {
        name: 'EST',
        displayName: 'GMT-05:00 EST EST',
        nameLocalized: 'EST',
        abbreviationStandard: 'EST',
        id: 353
    },
    {
        name: 'EST5EDT',
        displayName: 'GMT-05:00 EST5EDT EST',
        nameLocalized: 'EST5EDT',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 354
    },
    {
        name: 'America/Fort_Wayne',
        displayName: 'GMT-05:00 Fort Wayne EST',
        nameLocalized: 'Fort Wayne',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 107
    },
    {
        name: 'Etc/GMT-5',
        displayName: 'GMT-05:00 GMT-5 -05',
        nameLocalized: 'GMT-5',
        abbreviationStandard: '-05',
        id: 379
    },
    {
        name: 'Etc/GMT+5',
        displayName: 'GMT-05:00 GMT+5 -05',
        nameLocalized: 'GMT+5',
        abbreviationStandard: '-05',
        id: 364
    },
    {
        name: 'America/Indiana/Indianapolis',
        displayName: 'GMT-05:00 Indianapolis EST',
        nameLocalized: 'Indianapolis',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 121
    },
    {
        name: 'America/Kentucky/Louisville',
        displayName: 'GMT-05:00 Louisville EST',
        nameLocalized: 'Louisville',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 134
    },
    {
        name: 'America/Montreal',
        displayName: 'GMT-05:00 Montreal EST',
        nameLocalized: 'Montreal',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 154
    },
    {
        name: 'America/Nipigon',
        displayName: 'GMT-05:00 Nipigon EST',
        nameLocalized: 'Nipigon',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 158
    },
    {
        name: 'America/Pangnirtung',
        displayName: 'GMT-05:00 Pangnirtung EST',
        nameLocalized: 'Pangnirtung',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 164
    },
    {
        name: 'America/Porto_Acre',
        displayName: 'GMT-05:00 Porto Acre -05',
        nameLocalized: 'Porto Acre',
        abbreviationStandard: '-05',
        id: 169
    },
    {
        name: 'America/Thunder_Bay',
        displayName: 'GMT-05:00 Thunder Bay EST',
        nameLocalized: 'Thunder Bay',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 192
    },
    {
        name: 'America/Coral_Harbour',
        displayName: 'GMT-05:00 アティコカン EST',
        nameLocalized: 'アティコカン',
        abbreviationStandard: 'EST',
        id: 92
    },
    {
        name: 'America/Iqaluit',
        displayName: 'GMT-05:00 イカルイット EST',
        nameLocalized: 'イカルイット',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 130
    },
    {
        name: 'America/Indianapolis',
        displayName: 'GMT-05:00 インディアナポリス EST',
        nameLocalized: 'インディアナポリス',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 128
    },
    {
        name: 'America/Indiana/Winamac',
        displayName: 'GMT-05:00 インディアナ州ウィナマック EST',
        nameLocalized: 'インディアナ州ウィナマック',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 127
    },
    {
        name: 'America/Indiana/Petersburg',
        displayName: 'GMT-05:00 インディアナ州ピーターズバーグ EST',
        nameLocalized: 'インディアナ州ピーターズバーグ',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 124
    },
    {
        name: 'America/Indiana/Vevay',
        displayName: 'GMT-05:00 インディアナ州ビベー EST',
        nameLocalized: 'インディアナ州ビベー',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 125
    },
    {
        name: 'America/Indiana/Vincennes',
        displayName: 'GMT-05:00 インディアナ州ビンセンス EST',
        nameLocalized: 'インディアナ州ビンセンス',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 126
    },
    {
        name: 'America/Indiana/Marengo',
        displayName: 'GMT-05:00 インディアナ州マレンゴ EST',
        nameLocalized: 'インディアナ州マレンゴ',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 123
    },
    {
        name: 'America/Eirunepe',
        displayName: 'GMT-05:00 エイルネペ -05',
        nameLocalized: 'エイルネペ',
        abbreviationStandard: '-05',
        id: 104
    },
    {
        name: 'America/Cancun',
        displayName: 'GMT-05:00 カンクン EST',
        nameLocalized: 'カンクン',
        abbreviationStandard: 'EST',
        id: 85
    },
    {
        name: 'America/Guayaquil',
        displayName: 'GMT-05:00 グアヤキル -05/-04',
        nameLocalized: 'グアヤキル',
        abbreviationStandard: '-05/-04',
        id: 116
    },
    {
        name: 'America/Grand_Turk',
        displayName: 'GMT-05:00 グランドターク EST',
        nameLocalized: 'グランドターク',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 112
    },
    {
        name: 'America/Cayman',
        displayName: 'GMT-05:00 ケイマン EST',
        nameLocalized: 'ケイマン',
        abbreviationStandard: 'EST',
        id: 89
    },
    {
        name: 'America/Kentucky/Monticello',
        displayName: 'GMT-05:00 ケンタッキー州モンティチェロ EST',
        nameLocalized: 'ケンタッキー州モンティチェロ',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 135
    },
    {
        name: 'America/Jamaica',
        displayName: 'GMT-05:00 ジャマイカ EST',
        nameLocalized: 'ジャマイカ',
        abbreviationStandard: 'EST',
        id: 131
    },
    {
        name: 'America/Detroit',
        displayName: 'GMT-05:00 デトロイト EST',
        nameLocalized: 'デトロイト',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 101
    },
    {
        name: 'America/Toronto',
        displayName: 'GMT-05:00 トロント EST',
        nameLocalized: 'トロント',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 194
    },
    {
        name: 'America/Nassau',
        displayName: 'GMT-05:00 ナッソー EST',
        nameLocalized: 'ナッソー',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 156
    },
    {
        name: 'America/New_York',
        displayName: 'GMT-05:00 ニューヨーク EST',
        nameLocalized: 'ニューヨーク',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 157,
        enabled: true
    },
    {
        name: 'America/Panama',
        displayName: 'GMT-05:00 パナマ EST',
        nameLocalized: 'パナマ',
        abbreviationStandard: 'EST',
        id: 163
    },
    {
        name: 'America/Havana',
        displayName: 'GMT-05:00 ハバナ CST',
        nameLocalized: 'ハバナ',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 119
    },
    {
        name: 'America/Bogota',
        displayName: 'GMT-05:00 ボゴタ -05/-04',
        nameLocalized: 'ボゴタ',
        abbreviationStandard: '-05/-04',
        id: 80,
        enabled: true
    },
    {
        name: 'America/Port-au-Prince',
        displayName: 'GMT-05:00 ポルトープランス EST',
        nameLocalized: 'ポルトープランス',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 167
    },
    {
        name: 'America/Rio_Branco',
        displayName: 'GMT-05:00 リオブランコ -05',
        nameLocalized: 'リオブランコ',
        abbreviationStandard: '-05',
        id: 177
    },
    {
        name: 'America/Lima',
        displayName: 'GMT-05:00 リマ -05/-04',
        nameLocalized: 'リマ',
        abbreviationStandard: '-05/-04',
        id: 138
    },
    {
        name: 'America/Louisville',
        displayName: 'GMT-05:00 ルイビル EST',
        nameLocalized: 'ルイビル',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 140
    },
    {
        name: 'Canada/Central',
        displayName: 'GMT-06:00 Central CST',
        nameLocalized: 'Central',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 337
    },
    {
        name: 'CST6CDT',
        displayName: 'GMT-06:00 CST6CDT CST',
        nameLocalized: 'CST6CDT',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 348
    },
    {
        name: 'Mexico/General',
        displayName: 'GMT-06:00 General CST',
        nameLocalized: 'General',
        abbreviationStandard: 'CST',
        id: 479
    },
    {
        name: 'Etc/GMT-6',
        displayName: 'GMT-06:00 GMT-6 -06',
        nameLocalized: 'GMT-6',
        abbreviationStandard: '-06',
        id: 380
    },
    {
        name: 'Etc/GMT+6',
        displayName: 'GMT-06:00 GMT+6 -06',
        nameLocalized: 'GMT+6',
        abbreviationStandard: '-06',
        id: 365
    },
    {
        name: 'US/Indiana-Starke',
        displayName: 'GMT-06:00 Indiana-Starke CST',
        nameLocalized: 'Indiana-Starke',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 542
    },
    {
        name: 'America/Knox_IN',
        displayName: 'GMT-06:00 Knox IN CST',
        nameLocalized: 'Knox IN',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 136
    },
    {
        name: 'America/Rainy_River',
        displayName: 'GMT-06:00 Rainy River CST',
        nameLocalized: 'Rainy River',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 172
    },
    {
        name: 'Pacific/Easter',
        displayName: 'GMT-06:00 イースター島 -06/-05',
        nameLocalized: 'イースター島',
        abbreviationStandard: '-06/-05',
        abbreviationDaylight: '-06/-05',
        id: 488
    },
    {
        name: 'America/Indiana/Knox',
        displayName: 'GMT-06:00 インディアナ州ノックス CST',
        nameLocalized: 'インディアナ州ノックス',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 122
    },
    {
        name: 'America/Winnipeg',
        displayName: 'GMT-06:00 ウィニペグ CST',
        nameLocalized: 'ウィニペグ',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 199
    },
    {
        name: 'America/El_Salvador',
        displayName: 'GMT-06:00 エルサルバドル CST',
        nameLocalized: 'エルサルバドル',
        abbreviationStandard: 'CST',
        id: 105
    },
    {
        name: 'Pacific/Galapagos',
        displayName: 'GMT-06:00 ガラパゴス -06/-05',
        nameLocalized: 'ガラパゴス',
        abbreviationStandard: '-06/-05',
        id: 494
    },
    {
        name: 'America/Guatemala',
        displayName: 'GMT-06:00 グアテマラ CST',
        nameLocalized: 'グアテマラ',
        abbreviationStandard: 'CST',
        id: 115,
        enabled: true
    },
    {
        name: 'America/Costa_Rica',
        displayName: 'GMT-06:00 コスタリカ CST',
        nameLocalized: 'コスタリカ',
        abbreviationStandard: 'CST',
        id: 94
    },
    {
        name: 'America/Chicago',
        displayName: 'GMT-06:00 シカゴ CST',
        nameLocalized: 'シカゴ',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 90,
        enabled: true
    },
    {
        name: 'America/Swift_Current',
        displayName: 'GMT-06:00 スウィフトカレント CST',
        nameLocalized: 'スウィフトカレント',
        abbreviationStandard: 'CST',
        id: 189
    },
    {
        name: 'America/Chihuahua',
        displayName: 'GMT-06:00 チワワ CST',
        nameLocalized: 'チワワ',
        abbreviationStandard: 'CST',
        id: 91,
        enabled: true
    },
    {
        name: 'America/Tegucigalpa',
        displayName: 'GMT-06:00 テグシガルパ CST',
        nameLocalized: 'テグシガルパ',
        abbreviationStandard: 'CST',
        id: 190
    },
    {
        name: 'America/North_Dakota/Center',
        displayName: 'GMT-06:00 ノースダコタ州センター CST',
        nameLocalized: 'ノースダコタ州センター',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 161
    },
    {
        name: 'America/North_Dakota/New_Salem',
        displayName: 'GMT-06:00 ノースダコタ州ニューセーラム CST',
        nameLocalized: 'ノースダコタ州ニューセーラム',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 162
    },
    {
        name: 'America/Belize',
        displayName: 'GMT-06:00 ベリーズ CST',
        nameLocalized: 'ベリーズ',
        abbreviationStandard: 'CST',
        id: 77
    },
    {
        name: 'America/Managua',
        displayName: 'GMT-06:00 マナグア CST',
        nameLocalized: 'マナグア',
        abbreviationStandard: 'CST',
        id: 142
    },
    {
        name: 'America/Mexico_City',
        displayName: 'GMT-06:00 メキシコシティー CST',
        nameLocalized: 'メキシコシティー',
        abbreviationStandard: 'CST',
        id: 149,
        enabled: true
    },
    {
        name: 'America/Menominee',
        displayName: 'GMT-06:00 メノミニー CST',
        nameLocalized: 'メノミニー',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 147
    },
    {
        name: 'America/Merida',
        displayName: 'GMT-06:00 メリダ CST',
        nameLocalized: 'メリダ',
        abbreviationStandard: 'CST',
        id: 148
    },
    {
        name: 'America/Monterrey',
        displayName: 'GMT-06:00 モンテレイ CST',
        nameLocalized: 'モンテレイ',
        abbreviationStandard: 'CST',
        id: 152
    },
    {
        name: 'America/Rankin_Inlet',
        displayName: 'GMT-06:00 ランキンインレット CST',
        nameLocalized: 'ランキンインレット',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 173
    },
    {
        name: 'America/Regina',
        displayName: 'GMT-06:00 レジャイナ CST',
        nameLocalized: 'レジャイナ',
        abbreviationStandard: 'CST',
        id: 175
    },
    {
        name: 'America/Resolute',
        displayName: 'GMT-06:00 レゾリュート CST',
        nameLocalized: 'レゾリュート',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 176
    },
    {
        name: 'Mexico/BajaSur',
        displayName: 'GMT-07:00 BajaSur MST',
        nameLocalized: 'BajaSur',
        abbreviationStandard: 'MST',
        id: 478
    },
    {
        name: 'Etc/GMT-7',
        displayName: 'GMT-07:00 GMT-7 -07',
        nameLocalized: 'GMT-7',
        abbreviationStandard: '-07',
        id: 381
    },
    {
        name: 'Etc/GMT+7',
        displayName: 'GMT-07:00 GMT+7 -07',
        nameLocalized: 'GMT+7',
        abbreviationStandard: '-07',
        id: 366
    },
    {
        name: 'Canada/Mountain',
        displayName: 'GMT-07:00 Mountain MST',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 340
    },
    {
        name: 'MST',
        displayName: 'GMT-07:00 MST MST',
        nameLocalized: 'MST',
        abbreviationStandard: 'MST',
        id: 480
    },
    {
        name: 'MST7MDT',
        displayName: 'GMT-07:00 MST7MDT MST',
        nameLocalized: 'MST7MDT',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 481
    },
    {
        name: 'America/Yellowknife',
        displayName: 'GMT-07:00 Yellowknife MST',
        nameLocalized: 'Yellowknife',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 201
    },
    {
        name: 'Canada/Yukon',
        displayName: 'GMT-07:00 Yukon MST',
        nameLocalized: 'Yukon',
        abbreviationStandard: 'MST',
        id: 344
    },
    {
        name: 'America/Inuvik',
        displayName: 'GMT-07:00 イヌヴィク MST',
        nameLocalized: 'イヌヴィク',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 129
    },
    {
        name: 'America/Edmonton',
        displayName: 'GMT-07:00 エドモントン MST',
        nameLocalized: 'エドモントン',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 103
    },
    {
        name: 'America/Hermosillo',
        displayName: 'GMT-07:00 エルモシヨ MST',
        nameLocalized: 'エルモシヨ',
        abbreviationStandard: 'MST',
        id: 120
    },
    {
        name: 'America/Cambridge_Bay',
        displayName: 'GMT-07:00 ケンブリッジベイ MST',
        nameLocalized: 'ケンブリッジベイ',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 83
    },
    {
        name: 'America/Denver',
        displayName: 'GMT-07:00 デンバー MST',
        nameLocalized: 'デンバー',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 100,
        enabled: true
    },
    {
        name: 'America/Dawson',
        displayName: 'GMT-07:00 ドーソン MST',
        nameLocalized: 'ドーソン',
        abbreviationStandard: 'MST',
        id: 98
    },
    {
        name: 'America/Dawson_Creek',
        displayName: 'GMT-07:00 ドーソンクリーク MST',
        nameLocalized: 'ドーソンクリーク',
        abbreviationStandard: 'MST',
        id: 99
    },
    {
        name: 'America/Phoenix',
        displayName: 'GMT-07:00 フェニックス MST',
        nameLocalized: 'フェニックス',
        abbreviationStandard: 'MST',
        id: 166,
        enabled: true
    },
    {
        name: 'America/Boise',
        displayName: 'GMT-07:00 ボイシ MST',
        nameLocalized: 'ボイシ',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 81
    },
    {
        name: 'America/Whitehorse',
        displayName: 'GMT-07:00 ホワイトホース MST',
        nameLocalized: 'ホワイトホース',
        abbreviationStandard: 'MST',
        id: 198
    },
    {
        name: 'America/Mazatlan',
        displayName: 'GMT-07:00 マサトラン MST',
        nameLocalized: 'マサトラン',
        abbreviationStandard: 'MST',
        id: 145
    },
    {
        name: 'America/Ensenada',
        displayName: 'GMT-08:00 Ensenada PST',
        nameLocalized: 'Ensenada',
        abbreviationStandard: 'PST',
        id: 106
    },
    {
        name: 'Etc/GMT-8',
        displayName: 'GMT-08:00 GMT-8 -08',
        nameLocalized: 'GMT-8',
        abbreviationStandard: '-08',
        id: 382
    },
    {
        name: 'Etc/GMT+8',
        displayName: 'GMT-08:00 GMT+8 -08',
        nameLocalized: 'GMT+8',
        abbreviationStandard: '-08',
        id: 367
    },
    {
        name: 'Canada/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 342
    },
    {
        name: 'US/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 545
    },
    {
        name: 'PST8PDT',
        displayName: 'GMT-08:00 PST8PDT PST',
        nameLocalized: 'PST8PDT',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 528
    },
    {
        name: 'America/Tijuana',
        displayName: 'GMT-08:00 ティフアナ PST',
        nameLocalized: 'ティフアナ',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 193,
        enabled: true
    },
    {
        name: 'America/Vancouver',
        displayName: 'GMT-08:00 バンクーバー PST',
        nameLocalized: 'バンクーバー',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 196
    },
    {
        name: 'Pacific/Pitcairn',
        displayName: 'GMT-08:00 ピトケアン諸島 -08',
        nameLocalized: 'ピトケアン諸島',
        abbreviationStandard: '-08',
        id: 512
    },
    {
        name: 'America/Los_Angeles',
        displayName: 'GMT-08:00 ロサンゼルス PST',
        nameLocalized: 'ロサンゼルス',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 139,
        enabled: true
    },
    {
        name: 'Pacific/Marquesas',
        displayName: 'GMT-09:30 マルキーズ -0930',
        nameLocalized: 'マルキーズ',
        abbreviationStandard: '-0930',
        id: 504
    },
    {
        name: 'US/Alaska',
        displayName: 'GMT-09:00 Alaska AKST',
        nameLocalized: 'Alaska',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 535
    },
    {
        name: 'Etc/GMT-9',
        displayName: 'GMT-09:00 GMT-9 -09',
        nameLocalized: 'GMT-9',
        abbreviationStandard: '-09',
        id: 383
    },
    {
        name: 'Etc/GMT+9',
        displayName: 'GMT-09:00 GMT+9 -09',
        nameLocalized: 'GMT+9',
        abbreviationStandard: '-09',
        id: 368
    },
    {
        name: 'America/Anchorage',
        displayName: 'GMT-09:00 アンカレッジ AKST',
        nameLocalized: 'アンカレッジ',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 55
    },
    {
        name: 'Pacific/Gambier',
        displayName: 'GMT-09:00 ガンビエ諸島 -09',
        nameLocalized: 'ガンビエ諸島',
        abbreviationStandard: '-09',
        id: 495
    },
    {
        name: 'America/Juneau',
        displayName: 'GMT-09:00 ジュノー AKST',
        nameLocalized: 'ジュノー',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 133,
        enabled: true
    },
    {
        name: 'America/Nome',
        displayName: 'GMT-09:00 ノーム AKST',
        nameLocalized: 'ノーム',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 159
    },
    {
        name: 'America/Yakutat',
        displayName: 'GMT-09:00 ヤクタット AKST',
        nameLocalized: 'ヤクタット',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 200
    },
    {
        name: 'Etc/GMT-10',
        displayName: 'GMT-10:00 GMT-10 -10',
        nameLocalized: 'GMT-10',
        abbreviationStandard: '-10',
        id: 371
    },
    {
        name: 'Etc/GMT+10',
        displayName: 'GMT-10:00 GMT+10 -10',
        nameLocalized: 'GMT+10',
        abbreviationStandard: '-10',
        id: 358
    },
    {
        name: 'US/Hawaii',
        displayName: 'GMT-10:00 Hawaii HST',
        nameLocalized: 'Hawaii',
        abbreviationStandard: 'HST',
        id: 541
    },
    {
        name: 'HST',
        displayName: 'GMT-10:00 HST HST',
        nameLocalized: 'HST',
        abbreviationStandard: 'HST',
        id: 457
    },
    {
        name: 'Pacific/Johnston',
        displayName: 'GMT-10:00 Johnston HST',
        nameLocalized: 'Johnston',
        abbreviationStandard: 'HST',
        id: 499
    },
    {
        name: 'America/Adak',
        displayName: 'GMT-10:00 アダック HST',
        nameLocalized: 'アダック',
        abbreviationStandard: 'HST',
        abbreviationDaylight: 'HDT',
        id: 54
    },
    {
        name: 'Pacific/Tahiti',
        displayName: 'GMT-10:00 タヒチ -10',
        nameLocalized: 'タヒチ',
        abbreviationStandard: '-10',
        id: 518
    },
    {
        name: 'Pacific/Honolulu',
        displayName: 'GMT-10:00 ホノルル HST',
        nameLocalized: 'ホノルル',
        abbreviationStandard: 'HST',
        id: 498,
        enabled: true
    },
    {
        name: 'Pacific/Rarotonga',
        displayName: 'GMT-10:00 ラロトンガ -10/-0930',
        nameLocalized: 'ラロトンガ',
        abbreviationStandard: '-10/-0930',
        id: 515
    },
    {
        name: 'Etc/GMT-11',
        displayName: 'GMT-11:00 GMT-11 -11',
        nameLocalized: 'GMT-11',
        abbreviationStandard: '-11',
        id: 372
    },
    {
        name: 'Etc/GMT+11',
        displayName: 'GMT-11:00 GMT+11 -11',
        nameLocalized: 'GMT+11',
        abbreviationStandard: '-11',
        id: 359
    },
    {
        name: 'Pacific/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 517
    },
    {
        name: 'US/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 547
    },
    {
        name: 'Pacific/Niue',
        displayName: 'GMT-11:00 ニウエ -11',
        nameLocalized: 'ニウエ',
        abbreviationStandard: '-11',
        id: 507
    },
    {
        name: 'Pacific/Pago_Pago',
        displayName: 'GMT-11:00 パゴパゴ SST',
        nameLocalized: 'パゴパゴ',
        abbreviationStandard: 'SST',
        id: 510
    },
    {
        name: 'Pacific/Midway',
        displayName: 'GMT-11:00 ミッドウェー島 SST',
        nameLocalized: 'ミッドウェー島',
        abbreviationStandard: 'SST',
        id: 505,
        enabled: true
    },
    {
        name: 'Etc/GMT-12',
        displayName: 'GMT-12:00 GMT-12 -12',
        nameLocalized: 'GMT-12',
        abbreviationStandard: '-12',
        id: 373
    },
    {
        name: 'Etc/GMT+12',
        displayName: 'GMT-12:00 GMT+12 -12',
        nameLocalized: 'GMT+12',
        abbreviationStandard: '-12',
        id: 360
    },
];

const weekData: WeekData = {
    firstDay: 0,
    weekendStart: 6,
    weekendEnd: 0
};

const weekDayNames: WeekDayNameData = {
    days: {
        abbreviated: {
            sun: '日',
            mon: '月',
            tue: '火',
            wed: '水',
            thu: '木',
            fri: '金',
            sat: '土',
        },
        narrow: {
            sun: '日',
            mon: '月',
            tue: '火',
            wed: '水',
            thu: '木',
            fri: '金',
            sat: '土',
        },
        short: {
            sun: '日',
            mon: '月',
            tue: '火',
            wed: '水',
            thu: '木',
            fri: '金',
            sat: '土',
        },
        wide: {
            sun: '日曜日',
            mon: '月曜日',
            tue: '火曜日',
            wed: '水曜日',
            thu: '木曜日',
            fri: '金曜日',
            sat: '土曜日',
        },
    },
    standAlone: {
        abbreviated: {
            sun: '日',
            mon: '月',
            tue: '火',
            wed: '水',
            thu: '木',
            fri: '金',
            sat: '土',
        },
        narrow: {
            sun: '日',
            mon: '月',
            tue: '火',
            wed: '水',
            thu: '木',
            fri: '金',
            sat: '土',
        },
        short: {
            sun: '日',
            mon: '月',
            tue: '火',
            wed: '水',
            thu: '木',
            fri: '金',
            sat: '土',
        },
        wide: {
            sun: '日曜日',
            mon: '月曜日',
            tue: '火曜日',
            wed: '水曜日',
            thu: '木曜日',
            fri: '金曜日',
            sat: '土曜日',
        },
    },
};

const data: LocaleData = {
    languages,
    numbers,
    timezones,
    weekData,
    weekDayNames
};

export default data;
